/**
 * NUVI KIDZ — consolidated theme JS (single classic script, no bundler,
 * no ES module imports — matches the sample theme's asset pattern).
 *
 * Sections:
 *   1. Festival data
 *   2. Day / night theme
 *   3. Festival theme + picker
 *   4. Festival visual effects (crackers, snow+tree, moon, petals, confetti, colours)
 *   5. Header (sticky, mega menu, mobile menu)
 *   6. Scroll journey progress bar
 *   7. Announcement bar rotation
 *   8. Hero slider
 *   9. Ajax cart
 *   10. Product form (variant selection)
 *   11. Collection filters / sort
 *   12. Carousels (reviews, category rail)
 */
(function () {
  'use strict';

  /* ======================================================
     1. FESTIVAL DATA
     ====================================================== */
  var FESTIVALS = [
    {
      id: 'diwali', label: 'Diwali', emoji: '🪔',
      dateRanges: [{ startMonth: 10, startDay: 12, endMonth: 11, endDay: 15 }],
      colors: { gold: '#D9A400', peach: '#E9622D', lavender: '#5C1A2E', sage: '#8A4B12' },
      fontDisplay: "'Yeseva One', cursive",
      announcements: ['✨ Diwali Sale — up to 30% off little styles ✨', '🪔 Free gift wrap on every order this Diwali', '✨ Happy Diwali from the NUVI Universe ✨'],
      effect: 'crackers',
    },
    {
      id: 'ganesh-chaturthi', label: 'Ganesh Chaturthi', emoji: '🐘',
      dateRanges: [{ startMonth: 8, startDay: 22, endMonth: 9, endDay: 17 }],
      colors: { gold: '#E8A324', peach: '#D8482A', lavender: '#274E13', sage: '#4C7A2A' },
      fontDisplay: "'Yatra One', cursive",
      announcements: ['🐘 Happy Ganesh Chaturthi from the NUVI Universe 🐘', '🌼 Festive styles have landed — shop the collection', '🐘 Free shipping on orders over ₹999'],
      effect: 'petals',
    },
    {
      id: 'navratri', label: 'Navratri', emoji: '💃',
      dateRanges: [{ startMonth: 9, startDay: 22, endMonth: 10, endDay: 2 }],
      colors: { gold: '#E0A400', peach: '#D6336C', lavender: '#3A1E70', sage: '#0E7C7B' },
      fontDisplay: "'Kalam', cursive",
      announcements: ['💃 Happy Navratri from the NUVI Universe 💃', '🎶 Nine nights of little styles — shop festive wear', '💃 Garba-ready sets, now in store'],
      effect: 'colors',
    },
    {
      id: 'raksha-bandhan', label: 'Raksha Bandhan', emoji: '🎗️',
      dateRanges: [{ startMonth: 8, startDay: 1, endMonth: 8, endDay: 20 }],
      colors: { gold: '#D9A441', peach: '#E0607E', lavender: '#7A2340', sage: '#B9772F' },
      fontDisplay: "'Rozha One', serif",
      announcements: ['🎗️ Happy Raksha Bandhan from the NUVI Universe 🎗️', '💝 Sibling sets now available — shop matching styles', '🎗️ Free gift card with orders over ₹1,499'],
      effect: 'petals',
    },
    {
      id: 'eid', label: 'Eid', emoji: '🌙', autoDetect: false,
      dateRanges: [{ startMonth: 3, startDay: 30, endMonth: 4, endDay: 2 }],
      colors: { gold: '#C9A227', peach: '#1E7A5F', lavender: '#0B3D2E', sage: '#2F8F6B' },
      fontDisplay: "'Katibeh', cursive",
      announcements: ['🌙 Eid Mubarak from the NUVI Universe 🌙', '✨ Eid styles now in store — soft, festive, comfortable', '🌙 Free shipping across India this Eid'],
      effect: 'moon',
    },
    {
      id: 'christmas', label: 'Christmas', emoji: '🎄',
      dateRanges: [{ startMonth: 12, startDay: 1, endMonth: 12, endDay: 26 }],
      colors: { gold: '#C0392B', peach: '#2E7D5B', lavender: '#0F3D2E', sage: '#2E7D5B' },
      fontDisplay: "'Mountains of Christmas', cursive",
      announcements: ['❄️ Happy Holidays from the NUVI Universe ❄️', '🎄 Christmas styles now under the tree', '❄️ Free gift wrap on every order this season'],
      effect: 'snow-tree',
    },
    {
      id: 'holi', label: 'Holi', emoji: '🎨',
      dateRanges: [{ startMonth: 3, startDay: 1, endMonth: 3, endDay: 20 }],
      colors: { gold: '#E94E77', peach: '#3AA6A0', lavender: '#7B4FA6', sage: '#F2B705' },
      fontDisplay: "'Baloo 2', cursive",
      announcements: ['🎉 Happy Holi from the NUVI Universe 🎉', '🎨 Colour-fast festive styles — built for Holi', '🎉 Splash of savings — up to 25% off'],
      effect: 'colors',
    },
    {
      id: 'new-year', label: 'New Year', emoji: '🎆',
      dateRanges: [{ startMonth: 12, startDay: 27, endMonth: 1, endDay: 5 }],
      colors: { gold: '#EAB83D', peach: '#D9C7EA', lavender: '#241B4D', sage: '#9AA38C' },
      fontDisplay: "'Paytone One', sans-serif",
      announcements: ['🎆 Happy New Year from the NUVI Universe 🎆', '✨ New year, new little styles — shop now', '🎆 Ring it in with 20% off new arrivals'],
      effect: 'confetti',
    },
  ];

  var DEFAULT_THEME = { gold: '#EAB83D', peach: '#F2B49A', lavender: '#D9D2E9', sage: '#9AA38C', fontDisplay: "'Baloo 2', cursive" };

  function isDateInRange(month, day, range) {
    var value = month * 100 + day;
    var start = range.startMonth * 100 + range.startDay;
    var end = range.endMonth * 100 + range.endDay;
    if (start <= end) return value >= start && value <= end;
    return value >= start || value <= end;
  }
  function getFestivalFromDate(date) {
    date = date || new Date();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    for (var i = 0; i < FESTIVALS.length; i++) {
      var f = FESTIVALS[i];
      if (f.autoDetect === false) continue;
      for (var j = 0; j < f.dateRanges.length; j++) {
        if (isDateInRange(month, day, f.dateRanges[j])) return f;
      }
    }
    return null;
  }
  function findFestival(id) {
    for (var i = 0; i < FESTIVALS.length; i++) if (FESTIVALS[i].id === id) return FESTIVALS[i];
    return null;
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ======================================================
     2. DAY / NIGHT THEME
     Purely admin-controlled via Theme settings (nuvi_day_night_override):
     'auto' detects the visitor's local device time; 'day'/'night' locks
     the whole storefront to that mode for every visitor. There is no
     visitor-facing toggle — this is a merchant setting, not a UI control.
     ====================================================== */
  function getModeFromLocalTime(date) {
    var hour = (date || new Date()).getHours();
    return hour >= 6 && hour < 18 ? 'day' : 'night';
  }

  function applyDayNightMode(mode) {
    var root = document.documentElement;
    root.dataset.dayNight = mode;
    if (mode === 'day') {
      root.style.setProperty('--nuvi-bg', 'var(--color-cream)');
      root.style.setProperty('--nuvi-text', 'var(--color-nuvi-green)');
    } else {
      root.style.setProperty('--nuvi-bg', 'var(--color-night-green)');
      root.style.setProperty('--nuvi-text', 'var(--color-moon-cream)');
    }
    document.dispatchEvent(new CustomEvent('nuvi:day-night-change', { detail: { mode: mode } }));
  }

  function initDayNight() {
    var body = document.body;
    if (body.dataset.enableDayNight === 'false') {
      applyDayNightMode('day');
      return;
    }

    var forced = body.dataset.dayNightOverride || 'auto';
    applyDayNightMode(forced === 'auto' ? getModeFromLocalTime() : forced);

    // Auto mode re-checks the visitor's local time periodically (covers a
    // tab left open across the day/night boundary). A forced mode never
    // changes on its own — it stays whatever the merchant set.
    if (forced === 'auto') {
      setInterval(function () {
        applyDayNightMode(getModeFromLocalTime());
      }, 60 * 1000);
    }

    document.addEventListener('visibilitychange', function () {
      document.documentElement.dataset.tabHidden = document.hidden ? 'true' : 'false';
    });
  }

  /* ======================================================
     3. FESTIVAL THEME
     Purely admin-controlled via Theme settings (nuvi_festival_override):
     'auto' detects by today's date; 'none' always uses the regular theme;
     a specific festival id locks that theme on for every visitor. No
     visitor-facing picker — this is a merchant setting, not a UI control.
     ====================================================== */
  function applyFestivalTheme(festival) {
    var root = document.documentElement;
    var theme = festival ? Object.assign({}, DEFAULT_THEME, festival.colors, { fontDisplay: festival.fontDisplay }) : DEFAULT_THEME;
    root.style.setProperty('--nuvi-gold', theme.gold);
    root.style.setProperty('--nuvi-peach', theme.peach);
    root.style.setProperty('--nuvi-lavender', theme.lavender);
    root.style.setProperty('--nuvi-sage', theme.sage);
    root.style.setProperty('--nuvi-font-display', theme.fontDisplay);
    root.dataset.festival = festival ? festival.id : 'none';
    document.dispatchEvent(new CustomEvent('nuvi:festival-change', { detail: { festival: festival } }));
  }

  function resolveActiveFestival(override) {
    if (override === 'none') return null;
    if (!override || override === 'auto') return getFestivalFromDate();
    return findFestival(override);
  }

  function initFestivals() {
    var body = document.body;
    if (body.dataset.enableFestivals === 'false') {
      applyFestivalTheme(null);
      return;
    }

    var forced = body.dataset.festivalOverride || 'auto';
    applyFestivalTheme(resolveActiveFestival(forced));

    // Auto mode re-checks the date periodically (covers a tab left open
    // across midnight, or into/out of a festival window).
    if (forced === 'auto') {
      setInterval(function () {
        applyFestivalTheme(resolveActiveFestival('auto'));
      }, 60 * 1000);
    }
  }

  /* ======================================================
     4. FESTIVAL VISUAL EFFECTS
     ====================================================== */
  var CRACKER_COLORS = ['#FFD98A', '#F6E8CE', '#E9622D', '#D9A400', '#FF6B6B'];
  var CONFETTI_COLORS = ['#EAB83D', '#D9C7EA', '#F2B49A', '#9AA38C', '#FFF9F3', '#FF6B6B'];

  function fxEl(tag, className, styles) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (styles) Object.assign(node.style, styles);
    return node;
  }
  function fxDualShadow(color) {
    return '0 0 10px 3px ' + color + '99, 0 1px 4px rgba(23,45,42,0.45)';
  }
  function fxRandom(min, max) { return min + Math.random() * (max - min); }

  function buildCrackerBurst(x, y, delay, big) {
    var wrap = fxEl('div');
    wrap.style.position = 'absolute';
    wrap.style.left = x + '%';
    wrap.style.top = y + '%';

    wrap.appendChild(fxEl('span', 'fx-flash nuvi-pause-hidden', {
      width: (big ? 70 : 50) + 'px', height: (big ? 70 : 50) + 'px', left: '0', top: '0',
      transform: 'translate(-50%,-50%)',
      background: 'radial-gradient(circle, rgba(255,217,138,0.85), rgba(233,98,45,0.25) 60%, transparent 75%)',
      animationDelay: delay + 's',
    }));

    var sparkCount = big ? 14 : 10;
    var reach = big ? 34 : 24;
    for (var i = 0; i < sparkCount; i++) {
      var angle = (360 / sparkCount) * i;
      var color = CRACKER_COLORS[i % CRACKER_COLORS.length];
      wrap.appendChild(fxEl('span', 'fx-spark nuvi-pause-hidden', {
        width: (big ? 4 : 3) + 'px', height: (big ? 4 : 3) + 'px',
        background: color, boxShadow: fxDualShadow(color),
        transform: 'rotate(' + angle + 'deg) translateY(-' + reach + 'px)',
        animationDelay: delay + 's',
      }));
    }
    return wrap;
  }

  function renderCrackers(container) {
    var bursts = [
      { x: 10, y: 16, delay: 0, big: true }, { x: 82, y: 22, delay: 1.0, big: false },
      { x: 46, y: 10, delay: 2.1, big: true }, { x: 92, y: 46, delay: 0.55, big: false },
      { x: 24, y: 52, delay: 1.6, big: false }, { x: 66, y: 30, delay: 2.7, big: true },
    ];
    bursts.forEach(function (b) { container.appendChild(buildCrackerBurst(b.x, b.y, b.delay, b.big)); });

    var row = fxEl('div', 'fx-diya-row');
    for (var i = 0; i < 5; i++) {
      row.appendChild(fxEl('span', 'fx-diya nuvi-pause-hidden', { animationDelay: (i * 0.28) + 's' }));
    }
    container.appendChild(row);
  }

  function renderFallingParticles(container, effect, festivalColors) {
    var isSnow = effect === 'snow-tree';
    var isPetal = effect === 'petals';
    var count = isSnow ? 34 : isPetal ? 26 : 30;
    var petalPalette = festivalColors ? [festivalColors.peach, festivalColors.gold, festivalColors.sage] : CONFETTI_COLORS;

    for (var i = 0; i < count; i++) {
      var size = isSnow ? fxRandom(4, 7) : isPetal ? fxRandom(11, 17) : fxRandom(6, 10);
      var color = isPetal ? petalPalette[i % petalPalette.length] : CONFETTI_COLORS[i % CONFETTI_COLORS.length];
      var particle = fxEl('span', 'fx-particle nuvi-pause-hidden ' + (isPetal ? 'fx-particle--petal' : isSnow ? '' : 'fx-particle--confetti'), {
        left: fxRandom(0, 100) + '%', top: '-5%',
        width: size + 'px', height: (isPetal ? size * 1.5 : size) + 'px',
        background: isSnow ? '#FFF9F3' : color,
        boxShadow: isSnow ? fxDualShadow('#FFF9F3') : fxDualShadow(color),
        animationDelay: fxRandom(0, 6) + 's', animationDuration: fxRandom(5, 11) + 's',
      });
      particle.style.setProperty('--nuvi-drift', fxRandom(-50, 50) + 'px');
      container.appendChild(particle);
    }
  }

  function renderColorPuffs(container, festivalColors) {
    var puffs = [
      { x: 10, y: 18 }, { x: 28, y: 55 }, { x: 50, y: 12 }, { x: 70, y: 42 },
      { x: 88, y: 20 }, { x: 40, y: 68 }, { x: 60, y: 66 }, { x: 84, y: 60 },
    ];
    var palette = [festivalColors.peach, festivalColors.gold, festivalColors.lavender, festivalColors.sage];
    var isDay = document.documentElement.dataset.dayNight !== 'night';

    puffs.forEach(function (p, i) {
      container.appendChild(fxEl('span', 'fx-puff nuvi-pause-hidden', {
        left: p.x + '%', top: p.y + '%', width: '110px', height: '110px',
        background: palette[i % palette.length], opacity: '0.75',
        mixBlendMode: isDay ? 'multiply' : 'screen', animationDelay: (i * 0.5) + 's',
      }));
    });
  }

  function renderMoonStars(container, festivalColors) {
    for (var i = 0; i < 10; i++) {
      container.appendChild(fxEl('span', 'fx-star nuvi-pause-hidden', {
        left: fxRandom(0, 100) + '%', top: fxRandom(0, 70) + '%', width: '4px', height: '4px',
        background: festivalColors.gold, boxShadow: fxDualShadow(festivalColors.gold),
        animationDelay: fxRandom(0, 3) + 's',
      }));
    }
  }

  function buildChristmasTree(festivalColors) {
    var treeColor = festivalColors.peach, accent = festivalColors.lavender, gold = festivalColors.gold;
    var lights = [
      { x: 38, y: 78, c: gold }, { x: 62, y: 82, c: accent }, { x: 30, y: 60, c: accent },
      { x: 70, y: 58, c: gold }, { x: 42, y: 40, c: gold }, { x: 58, y: 42, c: accent },
    ];
    var lightsMarkup = lights.map(function (l, i) {
      return '<circle cx="' + l.x + '" cy="' + l.y + '" r="2.6" fill="' + l.c + '" class="nuvi-pause-hidden" style="animation:twinkle 3.4s ease-in-out infinite;animation-delay:' + (i * 0.3) + 's;transform-origin:' + l.x + 'px ' + l.y + 'px"/>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.innerHTML = '<svg viewBox="0 0 100 130" class="fx-tree" aria-hidden="true">' +
      '<rect x="45" y="112" width="10" height="14" rx="2" fill="#6B4226"/>' +
      '<polygon points="50,68 22,108 78,108" fill="' + treeColor + '"/>' +
      '<polygon points="50,42 27,82 73,82" fill="' + treeColor + '"/>' +
      '<polygon points="50,16 32,56 68,56" fill="' + treeColor + '"/>' +
      '<path d="M50 2 L53.5 10.5 L62.5 10.5 L55 15.8 L58 24.5 L50 19 L42 24.5 L45 15.8 L37.5 10.5 L46.5 10.5 Z" fill="' + gold + '"/>' +
      lightsMarkup + '</svg>';
    return wrap.firstElementChild;
  }

  function buildEidMoon(festivalColors) {
    var gold = festivalColors.gold, accent = festivalColors.peach;
    var stars = [
      { x: 12, y: 18, s: 3, d: 0 }, { x: 82, y: 12, s: 2.2, d: 0.6 }, { x: 20, y: 62, s: 2.4, d: 1.1 },
      { x: 88, y: 50, s: 3, d: 1.7 }, { x: 6, y: 42, s: 2, d: 2.2 },
    ];
    var starsMarkup = stars.map(function (s) {
      var p = 'M' + s.x + ' ' + (s.y - s.s) + ' L' + (s.x + s.s * 0.3) + ' ' + (s.y - s.s * 0.3) + ' L' + (s.x + s.s) + ' ' + s.y + ' L' + (s.x + s.s * 0.3) + ' ' + (s.y + s.s * 0.3) + ' L' + s.x + ' ' + (s.y + s.s) + ' L' + (s.x - s.s * 0.3) + ' ' + (s.y + s.s * 0.3) + ' L' + (s.x - s.s) + ' ' + s.y + ' L' + (s.x - s.s * 0.3) + ' ' + (s.y - s.s * 0.3) + ' Z';
      return '<path d="' + p + '" fill="' + accent + '" class="nuvi-pause-hidden" style="animation:twinkle 3.4s ease-in-out infinite;animation-delay:' + s.d + 's;transform-origin:' + s.x + 'px ' + s.y + 'px"/>';
    }).join('');

    var wrap = document.createElement('div');
    wrap.style.position = 'relative';
    wrap.style.width = '100%';
    wrap.style.height = '100%';
    wrap.innerHTML = '<span class="fx-moon-glow nuvi-pause-hidden" style="width:6rem;height:6rem;background:radial-gradient(circle, ' + gold + '88, transparent 70%);"></span>' +
      '<svg viewBox="0 0 100 100" class="fx-moon" aria-hidden="true" style="position:relative;">' +
      '<defs><mask id="nuvi-eid-crescent"><rect width="100" height="100" fill="white"/><circle cx="62" cy="38" r="26" fill="black"/></mask></defs>' +
      '<circle cx="48" cy="46" r="30" fill="' + gold + '" mask="url(#nuvi-eid-crescent)"/>' + starsMarkup + '</svg>';
    return wrap;
  }

  function fxClear(container) { if (container) container.innerHTML = ''; }

  function renderFestivalFx(festival) {
    var ambientContainers = document.querySelectorAll('[data-festival-fx="ambient"]');
    var centerpieceContainers = document.querySelectorAll('[data-festival-fx="centerpiece"]');

    ambientContainers.forEach(fxClear);
    centerpieceContainers.forEach(function (c) { fxClear(c); c.hidden = true; });

    if (!festival || document.body.dataset.festivalAnimations === 'false') return;

    ambientContainers.forEach(function (container) {
      switch (festival.effect) {
        case 'crackers': renderCrackers(container); break;
        case 'snow-tree': case 'confetti': case 'petals': renderFallingParticles(container, festival.effect, festival.colors); break;
        case 'colors': renderColorPuffs(container, festival.colors); break;
        case 'moon': renderMoonStars(container, festival.colors); break;
      }
    });

    if (festival.effect === 'snow-tree' || festival.effect === 'moon') {
      centerpieceContainers.forEach(function (container) {
        container.hidden = false;
        container.appendChild(festival.effect === 'snow-tree' ? buildChristmasTree(festival.colors) : buildEidMoon(festival.colors));
      });
    }
  }

  function initFestivalFxListener() {
    document.addEventListener('nuvi:festival-change', function (e) { renderFestivalFx(e.detail.festival); });
  }

  /* ---- global night-time star field ---- */
  function initGlobalStars() {
    var container = document.querySelector('[data-universe-stars]');
    if (!container || document.body.dataset.enableStars === 'false') return;
    var count = Number(document.body.dataset.starDensity || 40);
    for (var i = 0; i < count; i++) {
      container.appendChild(fxEl('span', 'universe-star nuvi-pause-hidden', {
        top: fxRandom(0, 100) + '%', left: fxRandom(0, 100) + '%',
        width: fxRandom(1.5, 3.5) + 'px', height: fxRandom(1.5, 3.5) + 'px',
        animationDelay: fxRandom(0, 3.4) + 's',
      }));
    }
  }

  /* ---- hero-scoped sky decoration (sun/moon/clouds/planets) ---- */
  function initHeroSky() {
    document.querySelectorAll('[data-universe-sky]').forEach(function (sky) {
      var stars = document.createElement('div');
      stars.className = 'nuvi-universe__stars';
      for (var i = 0; i < 16; i++) {
        stars.appendChild(fxEl('span', 'universe-star nuvi-pause-hidden', {
          top: fxRandom(0, 100) + '%', left: fxRandom(0, 100) + '%',
          width: fxRandom(1.5, 3) + 'px', height: fxRandom(1.5, 3) + 'px',
          animationDelay: fxRandom(0, 3.4) + 's',
        }));
      }
      sky.prepend(stars);
    });
  }

  /* ======================================================
     5. HEADER
     ====================================================== */
  /* Pure, side-effect-free — kept separate from initStickyHeader so the
     scroll math can be unit tested without a full DOM/browser. */
  function computeStickyHeaderTop(announceHeight, scrollY) {
    return Math.max(0, announceHeight - scrollY);
  }

  function isPastScrollThreshold(scrollY, threshold) {
    if (typeof threshold !== 'number') threshold = 8;
    return scrollY > threshold;
  }

  function initStickyHeader() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;

    if (header.classList.contains('site-header--static')) {
      var onScrollStatic = function () { header.classList.toggle('is-scrolled', isPastScrollThreshold(window.scrollY)); };
      onScrollStatic();
      window.addEventListener('scroll', onScrollStatic, { passive: true });
      return;
    }

    /* Fixed (not native CSS "sticky") on purpose: sticky positioning
       silently breaks — header stops pinning, mega menu gets clipped —
       the moment any ancestor picks up an overflow/transform/filter rule,
       which is easy to reintroduce by accident anywhere up the tree.
       Driving position via rAF-scroll keeps it correct regardless. */
    document.body.classList.add('has-fixed-header');
    var announce = document.getElementById('AnnouncementBar');
    var ticking = false;

    var setHeaderHeightVar = function () {
      document.documentElement.style.setProperty('--nuvi-header-h', header.offsetHeight + 'px');
    };

    var update = function () {
      var announceH = announce ? announce.offsetHeight : 0;
      var y = window.scrollY || window.pageYOffset || 0;
      header.style.top = computeStickyHeaderTop(announceH, y) + 'px';
      header.classList.toggle('is-scrolled', isPastScrollThreshold(y));
      ticking = false;
    };

    var onScroll = function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    setHeaderHeightVar();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { setHeaderHeightVar(); update(); });
  }

  function initMegaMenu() {
    var items = document.querySelectorAll('[data-nav-item]');
    items.forEach(function (item) {
      var megaMenu = item.querySelector('[data-mega-menu]');
      if (!megaMenu) return;
      var closeTimer;
      var open = function () {
        clearTimeout(closeTimer);
        items.forEach(function (i) { i.classList.remove('is-open'); });
        item.classList.add('is-open');
      };
      var scheduleClose = function () { closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 150); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduleClose);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') items.forEach(function (i) { i.classList.remove('is-open'); });
    });
  }

  function initMobileMenu() {
    var menu = document.querySelector('[data-mobile-menu]');
    var openBtn = document.querySelector('[data-mobile-menu-open]');
    var closeBtns = document.querySelectorAll('[data-mobile-menu-close]');
    if (!menu || !openBtn) return;

    var restartItemAnimations = function (screen) {
      if (!screen) return;
      screen.querySelectorAll('.mobile-menu__item, .mobile-menu__feature').forEach(function (item) {
        item.style.animation = 'none';
        void item.offsetWidth;
        item.style.animation = '';
      });
    };

    var open = function () {
      menu.hidden = false;
      requestAnimationFrame(function () {
        menu.classList.add('is-open');
        restartItemAnimations(menu.querySelector('.mobile-menu__screen.is-active'));
      });
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    };
    var close = function () {
      menu.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      setTimeout(function () {
        menu.hidden = true;
        menu.querySelectorAll('[data-menu-screen]').forEach(function (screen) {
          screen.classList.toggle('is-active', screen.getAttribute('data-menu-screen') === 'root');
          screen.removeAttribute('data-menu-anim');
        });
      }, 500);
    };

    openBtn.addEventListener('click', open);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    menu.querySelectorAll('a[href]').forEach(function (link) { link.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
    });

    menu.querySelectorAll('[data-menu-drill-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var targetScreen = menu.querySelector('[data-menu-screen="' + trigger.getAttribute('data-menu-drill-open') + '"]');
        var rootScreen = menu.querySelector('[data-menu-screen="root"]');
        if (!targetScreen || !rootScreen) return;
        rootScreen.classList.remove('is-active');
        targetScreen.classList.add('is-active');
        targetScreen.setAttribute('data-menu-anim', 'forward');
        restartItemAnimations(targetScreen);
      });
    });

    menu.querySelectorAll('[data-menu-drill-back]').forEach(function (backBtn) {
      backBtn.addEventListener('click', function () {
        var currentScreen = backBtn.closest('[data-menu-screen]');
        var rootScreen = menu.querySelector('[data-menu-screen="root"]');
        if (!currentScreen || !rootScreen) return;
        currentScreen.classList.remove('is-active');
        rootScreen.classList.add('is-active');
        rootScreen.setAttribute('data-menu-anim', 'back');
        restartItemAnimations(rootScreen);
      });
    });
  }

  function initSearchBar() {
    var bar = document.querySelector('[data-search-bar]');
    var openBtns = document.querySelectorAll('[data-search-open]');
    if (!bar || !openBtns.length) return;

    var closeBtn = bar.querySelector('[data-search-close]');
    var input = bar.querySelector('[data-search-input]');
    var focusTimer;

    var isOpenBtn = function (el) {
      return Array.prototype.some.call(openBtns, function (btn) { return btn === el || btn.contains(el); });
    };

    var open = function () {
      bar.hidden = false;
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
      openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
      clearTimeout(focusTimer);
      focusTimer = setTimeout(function () { if (input) input.focus(); }, 260);
    };
    var close = function () {
      bar.classList.remove('is-visible');
      openBtns.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
      clearTimeout(focusTimer);
      setTimeout(function () { bar.hidden = true; }, 300);
    };

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (bar.classList.contains('is-visible')) { close(); } else { open(); }
      });
    });
    closeBtn && closeBtn.addEventListener('click', function () {
      close();
      if (input) input.value = '';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && bar.classList.contains('is-visible')) close();
    });
    document.addEventListener('click', function (e) {
      if (!bar.classList.contains('is-visible')) return;
      if (bar.contains(e.target) || isOpenBtn(e.target)) return;
      close();
    });
  }

  function initMascotLoader() {
    var overlay = document.querySelector('[data-mascot-loader]');
    if (!overlay) return;
    var MIN_VISIBLE_MS = 500;
    var shownAt = Date.now();

    function hide() {
      var elapsed = Date.now() - shownAt;
      var wait = Math.max(0, MIN_VISIBLE_MS - elapsed);
      setTimeout(function () {
        overlay.classList.add('is-hidden');
        setTimeout(function () { overlay.hidden = true; }, 450);
      }, wait);
    }

    if (document.readyState === 'complete') {
      hide();
    } else {
      window.addEventListener('load', hide);
    }
  }

  function initFooterAccordions() {
    document.querySelectorAll('[data-footer-accordion-trigger]').forEach(function (trigger) {
      var panel = trigger.parentElement.querySelector('[data-footer-accordion-panel]');
      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.hidden = isOpen;
      });
    });
  }

  /* ======================================================
     6. SCROLL JOURNEY
     ====================================================== */
  function initScrollJourney() {
    var bar = document.querySelector('[data-scroll-journey]');
    if (!bar) return;
    var fill = bar.querySelector('[data-scroll-fill]');
    var capsule = bar.querySelector('[data-scroll-capsule]');
    var markers = bar.querySelectorAll('[data-pct]');
    var ticking = false;

    var update = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
      if (fill) fill.style.width = (pct * 100) + '%';
      if (capsule) capsule.style.left = (pct * 100) + '%';
      markers.forEach(function (m) { m.classList.toggle('is-passed', pct * 100 >= Number(m.dataset.pct)); });
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ======================================================
     7. ANNOUNCEMENT BAR
     ====================================================== */
  function initAnnouncementBar() {
    var bar = document.getElementById('AnnouncementBar');
    if (!bar) return;
    var list = bar.querySelector('[data-announce-list]');
    var prevBtn = bar.querySelector('[data-announce-prev]');
    var nextBtn = bar.querySelector('[data-announce-next]');
    if (!list) return;

    var defaultItemsHtml = Array.prototype.map.call(list.children, function (li) { return li.innerHTML.trim(); });
    var items = defaultItemsHtml;
    var index = 0;
    var timer;
    var isFestival = false;
    var rotateSpeed = Number(bar.dataset.rotateSpeed || 4200) || 4200;

    function renderItems() {
      list.innerHTML = '';
      items.forEach(function (html, i) {
        var li = document.createElement('li');
        li.className = 'announce__item' + (i === 0 ? ' is-active' : '') + (isFestival ? ' is-festival' : '');
        li.innerHTML = html;
        list.appendChild(li);
      });
    }
    function show(i) {
      index = (i + items.length) % items.length;
      Array.prototype.forEach.call(list.children, function (li, idx) { li.classList.toggle('is-active', idx === index); });
    }
    function next() { show(index + 1); }
    function restart() { clearInterval(timer); timer = setInterval(next, rotateSpeed); }

    prevBtn && prevBtn.addEventListener('click', function () { show(index - 1); restart(); });
    nextBtn && nextBtn.addEventListener('click', function () { next(); restart(); });
    restart();

    document.addEventListener('nuvi:festival-change', function (e) {
      var festival = e.detail.festival;
      isFestival = Boolean(festival);
      items = festival && festival.announcements ? festival.announcements : defaultItemsHtml;
      index = 0;
      renderItems();
      restart();
    });
  }

  function initOfferCountdown() {
    document.querySelectorAll('[data-offer-countdown]').forEach(function (bar) {
      var targetString = bar.dataset.countdownTarget;
      var target = targetString ? new Date(targetString).getTime() : NaN;
      if (!target || isNaN(target)) {
        bar.hidden = true;
        return;
      }

      var daysEl = bar.querySelector('[data-countdown-days]');
      var hoursEl = bar.querySelector('[data-countdown-hours]');
      var minutesEl = bar.querySelector('[data-countdown-minutes]');
      var secondsEl = bar.querySelector('[data-countdown-seconds]');

      function pad(n) { return String(n).length < 2 ? '0' + n : String(n); }

      function tick() {
        var diff = target - new Date().getTime();
        if (diff <= 0) {
          bar.hidden = true;
          clearInterval(intervalId);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      var intervalId = setInterval(tick, 1000);
    });
  }

  /* ======================================================
     8. HERO SLIDER
     ====================================================== */
  function initHeroSlider() {
    var hero = document.querySelector('[data-hero]');
    if (!hero) return;
    var slides = hero.querySelectorAll('[data-hero-slide]');
    var dots = hero.querySelectorAll('[data-hero-dot]');
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');
    var rocket = hero.querySelector('[data-hero-dots] svg');
    var count = slides.length;
    if (count <= 1) return;

    var index = 0;
    var timer;
    var autoplaySpeed = Number(hero.dataset.autoplaySpeed || 5800);

    function show(i) {
      index = (i + count) % count;
      slides.forEach(function (el, idx) { el.classList.toggle('is-active', idx === index); });
      dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === index); });
      if (rocket) {
        var dotEl = dots[index];
        if (dotEl) rocket.style.left = dotEl.offsetLeft + 'px';
      }
    }
    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function restart() { clearInterval(timer); timer = setInterval(next, autoplaySpeed); }

    prevBtn && prevBtn.addEventListener('click', function () { prev(); restart(); });
    nextBtn && nextBtn.addEventListener('click', function () { next(); restart(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); restart(); }); });

    show(0);
    restart();
  }

  // Clicking anywhere on a hero slide (not just its CTA button) navigates to
  // that slide's link, for every slide that has a button link set.
  function initHeroSlideLinks() {
    var slides = document.querySelectorAll('[data-hero-slide][data-hero-link]');
    if (!slides.length) return;

    slides.forEach(function (slide) {
      var url = slide.dataset.heroLink;
      if (!url) return;

      slide.addEventListener('click', function (e) {
        if (e.target.closest('.hero__cta')) return; // let the real link navigate itself
        window.location.href = url;
      });

      slide.addEventListener('keydown', function (e) {
        if (e.target !== slide) return; // don't hijack Enter on the CTA link itself
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          window.location.href = url;
        }
      });
    });
  }

  /* ======================================================
     9. AJAX CART
     ====================================================== */
  var CART_ROUTES = { add: '/cart/add.js', change: '/cart/change.js', get: '/cart.js' };

  function cartLineItemHtml(item) {
    var key = escapeHtml(item.key);
    var url = escapeHtml(item.url);
    var img = item.image
      ? '<img src="' + escapeHtml(String(item.image).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="' + escapeHtml(item.title) + '" width="80" height="80" loading="lazy">'
      : '<div class="cart-line__placeholder"></div>';
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '';
    return (
      '<li class="cart-line" data-cart-line data-line-key="' + key + '">' +
      '<a href="' + url + '" class="cart-line__media">' + img + '</a>' +
      '<div class="cart-line__details">' +
      '<div class="cart-line__row"><div><a href="' + url + '" class="cart-line__title">' + escapeHtml(item.product_title) + '</a>' + variantLine + '</div>' +
      '<button type="button" class="cart-line__remove" data-cart-remove data-line-key="' + key + '">Remove</button></div>' +
      '<div class="cart-line__row cart-line__row--bottom">' +
      '<div class="qty-stepper qty-stepper--sm">' +
      '<button type="button" data-cart-qty-decrease data-line-key="' + key + '" aria-label="Decrease quantity">−</button>' +
      '<span data-cart-qty-value>' + escapeHtml(item.quantity) + '</span>' +
      '<button type="button" data-cart-qty-increase data-line-key="' + key + '" aria-label="Increase quantity">+</button>' +
      '</div><p class="cart-line__price">' + escapeHtml(formatMoney(item.final_line_price)) + '</p></div>' +
      '</div></li>'
    );
  }

  // Escape text before it goes into an HTML string, so product/cart text
  // containing <, >, & or quotes always displays as text, never as markup.
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // Shopify product handles are lowercase letters, digits and dashes. Anything
  // else (e.g. a tampered localStorage entry) is ignored rather than fetched.
  function isValidHandle(handle) {
    return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]*$/.test(handle);
  }

  // Format cents with the store's own money format (layout/theme.liquid sets
  // window.NuviMoneyFormat from shop.money_format), so JS-rendered prices match
  // Liquid's | money output exactly, e.g. "Rs. 1,499.00".
  function formatMoney(cents, format) {
    var moneyFormat = format || (window.NuviMoneyFormat) ||
      (window.Shopify && window.Shopify.money_format) || 'Rs. {{amount}}';
    var amount = Number(cents);
    if (!isFinite(amount)) amount = 0;

    function group(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return group(amount, 2, ',', '.');
    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = group(amount, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = group(amount, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = group(amount, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = group(amount, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = group(amount, 2, ' ', ','); break;
      default: value = group(amount, 2, ',', '.');
    }
    // Money formats may include HTML (e.g. <span class=money>); prices here are
    // always plain text, so drop any tags.
    return moneyFormat.replace(match[0], value).replace(/<[^>]*>/g, '');
  }

  function renderCartDrawer(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    var total = document.querySelector('[data-cart-total]');
    var discountRow = document.querySelector('[data-cart-discount-row]');
    var discountAmount = document.querySelector('[data-cart-discount-amount]');
    var countEls = document.querySelectorAll('[data-cart-count]');

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-hidden', cart.item_count === 0);
    });

    renderDiscountStatus(cart);

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p class="cart-drawer__empty-title">Your bag is empty orbit</p>' +
        '<p class="cart-drawer__empty-text">Add a little something from the universe.</p>' +
        '<a href="/collections/all" class="btn btn--primary" data-cart-close>Explore new in</a></div>';
      if (foot) foot.hidden = true;
    } else {
      body.innerHTML = '<ul class="cart-drawer__list">' + cart.items.map(cartLineItemHtml).join('') + '</ul>';
      if (foot) {
        foot.hidden = false;
        if (total) total.textContent = formatMoney(cart.total_price);

        var hasDiscount = cart.total_discount > 0;
        if (discountRow) discountRow.hidden = !hasDiscount;
        if (discountAmount && hasDiscount) discountAmount.textContent = '−' + formatMoney(cart.total_discount);

      }
    }
  }

  // Shows which entered codes actually took effect. A code Shopify keeps on the
  // cart but cannot use (wrong products, minimum not met, expired, not
  // combinable...) comes back with applicable: false; say so instead of
  // silently showing the full price or, worse, calling it "applied".
  function renderDiscountStatus(cart) {
    var codes = (cart && cart.discount_codes) || [];
    var applied = codes.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
    var rejected = codes.filter(function (c) { return !c.applicable; }).map(function (c) { return c.code; });
    document.querySelectorAll('.cart-discount').forEach(function (wrap) {
      var appliedEl = wrap.querySelector('[data-cart-discount-applied]');
      var titleEl = wrap.querySelector('[data-cart-discount-title]');
      var invalidEl = wrap.querySelector('[data-cart-discount-invalid]');
      if (appliedEl) appliedEl.hidden = applied.length === 0;
      if (titleEl) titleEl.textContent = applied.join(', ');
      if (invalidEl) {
        invalidEl.hidden = rejected.length === 0;
        invalidEl.textContent = rejected.length
          ? '"' + rejected.join('", "') + '" can\'t be used with the items in your bag. Check the offer\'s minimum order and eligible products.'
          : '';
      }
    });
  }

  function applyDiscountCode(code, redirectPath) {
    code = (code || '').trim();
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath || '/cart');
  }

  function fetchCart() {
    return fetch(CART_ROUTES.get).then(function (r) { return r.json(); });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer) return;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { drawer.hidden = true; if (overlay) overlay.hidden = true; }, 350);
  }

  function flyToCart(originEvent) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var cartIcon = document.querySelector('[data-cart-icon]');
    if (!cartIcon) return;
    var targetRect = cartIcon.getBoundingClientRect();
    var originX = originEvent && originEvent.clientX ? originEvent.clientX : window.innerWidth / 2;
    var originY = originEvent && originEvent.clientY ? originEvent.clientY : window.innerHeight - 80;

    var dot = document.createElement('div');
    dot.style.cssText = 'position:fixed;z-index:90;left:' + originX + 'px;top:' + originY + 'px;width:14px;height:14px;border-radius:50%;background:var(--nuvi-gold);pointer-events:none;transition:all 0.7s cubic-bezier(0.3,0,0.4,1);opacity:1;';
    document.body.appendChild(dot);
    requestAnimationFrame(function () {
      dot.style.left = (targetRect.left + targetRect.width / 2) + 'px';
      dot.style.top = (targetRect.top + targetRect.height / 2) + 'px';
      dot.style.opacity = '0.2';
      dot.style.transform = 'scale(0.4)';
    });
    setTimeout(function () { dot.remove(); }, 750);

    cartIcon.classList.add('is-bouncing');
    setTimeout(function () { cartIcon.classList.remove('is-bouncing'); }, 400);
  }

  var quickAddToastTimer = null;
  function showQuickAddToast() {
    var toast = document.querySelector('[data-quick-add-toast]');
    if (!toast) return;
    clearTimeout(quickAddToastTimer);
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    quickAddToastTimer = setTimeout(hideQuickAddToast, 3000);
  }
  function hideQuickAddToast() {
    var toast = document.querySelector('[data-quick-add-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(function () { toast.hidden = true; }, 250);
  }

  function addToCart(variantId, quantity, originEvent, opts) {
    quantity = quantity || 1;
    opts = opts || {};
    var shouldOpenDrawer = opts.openDrawer !== false;
    var useDrawer = document.documentElement.dataset.cartType !== 'page';
    return fetch(CART_ROUTES.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw new Error(err.description || 'Could not add to cart'); });
        return fetchCart();
      })
      .then(function (cart) {
        renderCartDrawer(cart);
        if (originEvent) flyToCart(originEvent);
        if (!useDrawer) {
          window.location.href = '/cart';
        } else if (shouldOpenDrawer) {
          openCartDrawer();
        } else {
          showQuickAddToast();
        }
        return cart;
      })
      .catch(function (err) {
        alert(err.message || 'Something went wrong adding that to your bag.');
      });
  }

  function changeLineQuantity(key, quantity) {
    return fetch(CART_ROUTES.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); return cart; });
  }

  function initCart() {
    fetchCart().then(renderCartDrawer).catch(function () {});

    document.querySelectorAll('[data-cart-icon]').forEach(function (btn) { btn.addEventListener('click', openCartDrawer); });
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
    document.querySelectorAll('[data-cart-overlay]').forEach(function (el) { el.addEventListener('click', closeCartDrawer); });
    document.addEventListener('keydown', function (e) {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCartDrawer();
    });

    document.body.addEventListener('click', function (e) {
      var sizeChip = e.target.closest('[data-size-chip]');
      if (sizeChip) {
        if (sizeChip.disabled) return;
        var sizePanel = sizeChip.closest('.product-card__hover-panel');
        if (sizePanel) {
          sizePanel.querySelectorAll('[data-size-chip]').forEach(function (chip) { chip.classList.remove('is-selected'); });
          sizeChip.classList.add('is-selected');
          var linkedQuickAdd = sizePanel.querySelector('[data-quick-add]');
          if (linkedQuickAdd) linkedQuickAdd.dataset.variantId = sizeChip.dataset.variantId;
          var sizeHint = sizePanel.querySelector('[data-size-hint]');
          if (sizeHint) sizeHint.textContent = '';
        }
        return;
      }

      var quickAddBtn = e.target.closest('[data-quick-add]');
      if (quickAddBtn) {
        e.preventDefault();
        if (quickAddBtn.dataset.requiresSize === 'true' && !quickAddBtn.dataset.variantId) {
          var panel = quickAddBtn.closest('.product-card__hover-panel');
          var hint = panel && panel.querySelector('[data-size-hint]');
          if (hint) hint.textContent = 'Select a size first';
          if (panel && panel.animate) {
            panel.animate(
              [{ transform: 'translateX(0)' }, { transform: 'translateX(-4px)' }, { transform: 'translateX(4px)' }, { transform: 'translateX(0)' }],
              { duration: 250 }
            );
          }
          return;
        }
        addToCart(quickAddBtn.dataset.variantId, 1, e, { openDrawer: false });
        return;
      }

      var toastViewBtn = e.target.closest('[data-quick-add-toast-view]');
      if (toastViewBtn) {
        hideQuickAddToast();
        openCartDrawer();
        return;
      }

      var decreaseBtn = e.target.closest('[data-cart-qty-decrease]');
      var increaseBtn = e.target.closest('[data-cart-qty-increase]');
      var removeBtn = e.target.closest('[data-cart-remove]');

      if (decreaseBtn || increaseBtn) {
        var key = (decreaseBtn || increaseBtn).dataset.lineKey;
        var line = document.querySelector('[data-cart-line][data-line-key="' + key + '"]');
        var qtyEl = line && line.querySelector('[data-cart-qty-value]');
        var current = qtyEl ? Number(qtyEl.textContent) : 1;
        changeLineQuantity(key, decreaseBtn ? Math.max(0, current - 1) : current + 1);
      }
      if (removeBtn) changeLineQuantity(removeBtn.dataset.lineKey, 0);

      var discountBtn = e.target.closest('[data-discount-apply]');
      if (discountBtn) {
        var wrap = discountBtn.closest('.cart-discount');
        var input = wrap && wrap.querySelector('[data-discount-input]');
        if (input) applyDiscountCode(input.value, input.dataset.discountRedirect);
      }
    });

    document.body.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target.matches('[data-discount-input]')) return;
      e.preventDefault();
      applyDiscountCode(e.target.value, e.target.dataset.discountRedirect);
    });

    window.NuviCart = { addToCart: addToCart, openDrawer: openCartDrawer, closeDrawer: closeCartDrawer, applyDiscountCode: applyDiscountCode };
  }

  /* ======================================================
     10. PRODUCT FORM
     ====================================================== */
  function initProductForm() {
    var form = document.getElementById('ProductForm');
    if (!form) return;

    var jsonScript = document.querySelector('[data-product-json]');
    if (!jsonScript) return;
    var product;
    try { product = JSON.parse(jsonScript.textContent); } catch (err) { return; }

    var optionSelectors = form.querySelectorAll('[data-option-index]');
    var hiddenVariantInput = form.querySelector('[data-product-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = form.querySelector('[data-add-to-cart-label]');
    var buyNowBtn = form.querySelector('[data-buy-now]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');
    var priceSave = document.querySelector('[data-price-save]');
    var qtyInput = form.querySelector('[data-qty-input]');

    var stickyBtn = document.querySelector('[data-sticky-add-to-cart]');

    // Options marked data-option-required (Size) start with no value: the
    // shopper must pick one. Others fall back to the first variant's value.
    var selectedOptions = product.options.map(function (_, i) {
      var group = form.querySelector('.option-selector[data-option-index="' + i + '"]');
      var selectedBtn = form.querySelector('[data-option-index="' + i + '"] .is-selected');
      if (selectedBtn) return selectedBtn.dataset.value;
      return group && group.hasAttribute('data-option-required') ? null : product.variants[0].options[i];
    });

    // Name of the first option still to be chosen ("Size"), or null.
    function missingOption() {
      var index = selectedOptions.indexOf(null);
      return index === -1 ? null : { index: index, name: String(product.options[index]) };
    }

    function setMissingError(show) {
      form.querySelectorAll('.option-selector[data-option-required]').forEach(function (group) {
        var needed = show && selectedOptions[Number(group.dataset.optionIndex)] === null;
        group.classList.toggle('is-missing', needed);
        var error = group.querySelector('[data-option-error]');
        if (error) error.hidden = !needed;
      });
    }

    // Add to Bag / Buy Now / sticky bar pressed before choosing a size:
    // point the shopper at the size buttons instead of adding anything.
    function promptForMissingOption() {
      var missing = missingOption();
      if (!missing) return false;
      setMissingError(true);
      var group = form.querySelector('.option-selector[data-option-index="' + missing.index + '"]');
      if (group) {
        if (group.scrollIntoView) group.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstChoice = group.querySelector('[data-option-value]:not(.is-unavailable)') || group.querySelector('[data-option-value]');
        if (firstChoice) firstChoice.focus({ preventScroll: true });
      }
      return true;
    }

    function findVariant() {
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
      })[0];
    }

    var colorOptionIndex = product.options.map(function (name) { return String(name).toLowerCase(); })
      .reduce(function (found, name, i) { return found === -1 && (name === 'color' || name === 'colour') ? i : found; }, -1);

    // A value is sold out when the variant it makes with the other current
    // selections is missing or unavailable (e.g. size 2-3Y in Black).
    function isValueAvailable(index, value) {
      return product.variants.some(function (v) {
        return v.available && v.options.every(function (opt, i) {
          // An option not chosen yet (size) doesn't rule anything out.
          if (i !== index && selectedOptions[i] === null) return true;
          return opt === (i === index ? value : selectedOptions[i]);
        });
      });
    }

    function updateUI() {
      var variant = findVariant();

      if (colorOptionIndex > -1) filterGalleryByColor(selectedOptions[colorOptionIndex]);

      optionSelectors.forEach(function (group) {
        var index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var isSelected = btn.dataset.value === selectedOptions[index];
          btn.classList.toggle('is-selected', isSelected);
          btn.setAttribute('aria-pressed', String(isSelected));
          if (btn.classList.contains('pill-btn')) {
            var unavailable = !isValueAvailable(index, btn.dataset.value);
            btn.classList.toggle('is-unavailable', unavailable);
            btn.setAttribute('aria-label', btn.dataset.value + (unavailable ? ' - sold out' : ''));
          }
        });
        var selectedLabel = group.querySelector('[data-option-selected-label]');
        if (selectedLabel) selectedLabel.textContent = selectedOptions[index] || '';
      });

      var missing = missingOption();
      if (!missing) setMissingError(false);

      if (!variant) {
        if (hiddenVariantInput) hiddenVariantInput.value = '';
        // Still choosing: keep the buttons clickable so they can prompt for the size.
        var label = missing ? 'Select a ' + missing.name.toLowerCase() : 'Unavailable';
        if (addLabel) addLabel.textContent = label;
        if (stickyBtn) stickyBtn.textContent = label;
        [addBtn, buyNowBtn, stickyBtn].forEach(function (btn) {
          if (btn) btn.toggleAttribute('disabled', !missing);
        });
        return;
      }

      if (hiddenVariantInput) hiddenVariantInput.value = variant.id;
      if (priceNow) priceNow.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price > variant.price;
      if (priceWas) {
        if (onSale) priceWas.textContent = formatMoney(variant.compare_at_price);
        priceWas.hidden = !onSale;
      }
      if (priceSave) {
        // Rounded down, matching the Liquid: never claim more off than the real discount.
        if (onSale) priceSave.textContent = Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF';
        priceSave.hidden = !onSale;
      }

      var available = variant.available;
      if (addBtn) addBtn.toggleAttribute('disabled', !available);
      if (buyNowBtn) buyNowBtn.toggleAttribute('disabled', !available);
      if (stickyBtn) stickyBtn.toggleAttribute('disabled', !available);
      if (addLabel) addLabel.textContent = available ? 'Add to Bag' : 'Sold out';
      if (stickyBtn) stickyBtn.textContent = available ? 'Add to Bag' : 'Sold out';

      // Show the image assigned to this variant (e.g. a size) and keep thumbs + counter in sync.
      var variantSlide = variant.featured_media && document.querySelector('[data-gallery-slide][data-media-id="' + variant.featured_media.id + '"]');
      if (variantSlide && !variantSlide.hidden) {
        setActiveSlide(variantSlide.dataset.index);
      } else {
        // Current photo may belong to another colour now - fall back to the colour's
        // first own photo, else the first visible one.
        var activeSlide = document.querySelector('[data-gallery-slide].is-active');
        var visible = visibleSlides();
        var selectedColor = colorOptionIndex > -1 ? selectedOptions[colorOptionIndex] : null;
        var colorFirst = visible.filter(function (s) { return s.dataset.mediaColor === selectedColor; })[0];
        if (activeSlide && !activeSlide.hidden) setActiveSlide(activeSlide.dataset.index);
        else if (colorFirst || visible[0]) setActiveSlide((colorFirst || visible[0]).dataset.index);
      }

      if (variant.id && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('nuvi:variant-change', { detail: { variant: variant } }));
    }

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option-value]');
      if (!btn) return;
      var group = btn.closest('[data-option-index]');
      var index = Number(group.dataset.optionIndex);
      selectedOptions[index] = btn.dataset.value;
      updateUI();
    });

    var decreaseBtn = form.querySelector('[data-qty-decrease]');
    var increaseBtn = form.querySelector('[data-qty-increase]');
    decreaseBtn && decreaseBtn.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, Number(qtyInput.value) - 1); });
    increaseBtn && increaseBtn.addEventListener('click', function () { if (qtyInput) qtyInput.value = Number(qtyInput.value) + 1; });

    // Size guide click handling now lives in initSizeGuide() (a real modal).

    var gallerySlides = document.querySelectorAll('[data-gallery-slide]');
    var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
    var galleryCounter = document.querySelector('[data-gallery-counter]');

    var galleryArrows = document.querySelectorAll('[data-gallery-prev], [data-gallery-next]');

    function visibleSlides() {
      return Array.prototype.filter.call(gallerySlides, function (s) { return !s.hidden; });
    }

    // Show only the selected colour's photos plus shared ones (no colour). If the
    // colour has no photos of its own, show everything rather than an empty gallery.
    function filterGalleryByColor(color) {
      var hasOwnPhotos = Array.prototype.some.call(gallerySlides, function (s) { return s.dataset.mediaColor === color; });
      gallerySlides.forEach(function (s) {
        var mediaColor = s.dataset.mediaColor || '';
        s.hidden = hasOwnPhotos && mediaColor !== '' && mediaColor !== color;
      });
      galleryThumbs.forEach(function (t) {
        var slide = gallerySlides[Number(t.dataset.index)];
        t.hidden = slide ? slide.hidden : false;
      });
      var multiple = visibleSlides().length > 1;
      galleryArrows.forEach(function (btn) { btn.style.display = multiple ? '' : 'none'; });
      if (galleryCounter) galleryCounter.style.display = multiple ? '' : 'none';
    }

    function setActiveSlide(idx) {
      idx = String(idx);
      gallerySlides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.index === idx); });
      galleryThumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.index === idx); });
      var visible = visibleSlides();
      var position = visible.map(function (s) { return s.dataset.index; }).indexOf(idx);
      if (galleryCounter) galleryCounter.textContent = (position + 1) + ' / ' + visible.length;
    }

    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { setActiveSlide(thumb.dataset.index); });
    });

    // Step through the photos currently shown (the selected colour's), not all of them.
    function stepSlide(direction) {
      var visible = visibleSlides();
      if (!visible.length) return null;
      var activeSlide = document.querySelector('[data-gallery-slide].is-active');
      var current = Math.max(0, visible.indexOf(activeSlide));
      var next = visible[(current + direction + visible.length) % visible.length];
      setActiveSlide(next.dataset.index);
      return next;
    }

    if (gallerySlides.length > 1) {
      galleryArrows.forEach(function (btn) {
        btn.addEventListener('click', function () {
          stepSlide(btn.hasAttribute('data-gallery-next') ? 1 : -1);
        });
      });

      // Phones: swipe the main photo left/right to change it (the arrows are hidden there).
      // Mostly-vertical moves are left alone so the page still scrolls.
      var galleryMain = document.querySelector('.product-gallery__main');
      var touchX = null, touchY = null;
      if (galleryMain) {
        galleryMain.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { touchX = null; return; }
          touchX = e.touches[0].clientX;
          touchY = e.touches[0].clientY;
        }, { passive: true });
        galleryMain.addEventListener('touchend', function (e) {
          if (touchX === null) return;
          var dx = e.changedTouches[0].clientX - touchX;
          var dy = e.changedTouches[0].clientY - touchY;
          touchX = null;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          var direction = dx < 0 ? 1 : -1;
          var shown = stepSlide(direction);
          if (!shown) return;
          shown.classList.remove('is-entering-next', 'is-entering-prev');
          void shown.offsetWidth;
          shown.classList.add(direction === 1 ? 'is-entering-next' : 'is-entering-prev');
        }, { passive: true });
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (promptForMissingOption()) return;
      var variant = findVariant();
      if (!variant || !window.NuviCart) return;
      var qty = qtyInput ? Number(qtyInput.value) : 1;
      window.NuviCart.addToCart(variant.id, qty, e);
    });

    buyNowBtn && buyNowBtn.addEventListener('click', function (e) {
      if (promptForMissingOption()) return;
      var variant = findVariant();
      if (!variant || !window.NuviCart) return;
      var qty = qtyInput ? Number(qtyInput.value) : 1;
      window.NuviCart.addToCart(variant.id, qty, e).then(function () {
        window.location.href = '/checkout';
      });
    });

    updateUI();
  }

  /* ======================================================
     11. COLLECTION FILTERS / SORT
     ====================================================== */
  function initFilterDrawer() {
    var drawer = document.querySelector('[data-filter-drawer]');
    var openBtn = document.querySelector('[data-filter-drawer-open]');
    var closeBtns = document.querySelectorAll('[data-filter-drawer-close]');
    if (!drawer || !openBtn) return;
    openBtn.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', function () { drawer.hidden = true; document.body.style.overflow = ''; }); });
  }
  function initAccountGate() {
    var overlay = document.querySelector('[data-account-overlay]');
    var gate = document.querySelector('[data-account-gate]');
    var openBtns = document.querySelectorAll('[data-account-open]');
    var closeBtns = document.querySelectorAll('[data-account-close]');
    if (!gate || !openBtns.length) return;

    function openGate() {
      overlay.hidden = false;
      gate.hidden = false;
      requestAnimationFrame(function () {
        overlay.classList.add('is-open');
        gate.classList.add('is-open');
      });
      gate.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var closeBtn = gate.querySelector('[data-account-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeGate() {
      overlay.classList.remove('is-open');
      gate.classList.remove('is-open');
      gate.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (overlay) overlay.hidden = true;
        gate.hidden = true;
      }, 320);
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', openGate); });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', closeGate); });
    if (overlay) overlay.addEventListener('click', closeGate);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && gate.classList.contains('is-open')) closeGate();
    });
  }
  function initProductCardSwatches() {
    // Hovering a colour dot under a product card swaps the primary photo to
    // that variant's own image (data-swatch-image, set in
    // nuvi-product-card.liquid); moving away restores the card's default
    // featured image (data-default-src on the <img> itself).
    document.querySelectorAll('[data-color-swatches]').forEach(function (row) {
      var card = row.closest('.product-card');
      var img = card && card.querySelector('.product-card__image--primary');
      if (!img) return;
      row.querySelectorAll('.product-card__swatch').forEach(function (swatch) {
        var swatchImage = swatch.dataset.swatchImage;
        if (!swatchImage) return;
        swatch.addEventListener('mouseenter', function () { img.src = swatchImage; });
        swatch.addEventListener('mouseleave', function () { img.src = img.dataset.defaultSrc; });
      });
    });
  }

  function initClientFilters() {
    // Fully client-side filtering across Availability, Price, Discount, Category, Size
    // and Colour — driven entirely by data-* attributes on each product card
    // (see main-collection-product-grid.liquid), no Search & Discovery app
    // config required. The filters snippet is rendered twice (desktop
    // sidebar + mobile drawer); `mirror()` keeps both copies of the form in
    // sync so switching between them doesn't lose the selection.
    var forms = document.querySelectorAll('[data-filters-form]');
    if (!forms.length) return;
    var cards = document.querySelectorAll('[data-product-filter]');
    if (!cards.length) return;

    function key(input) {
      return input.dataset.filterGroup + ':' + (input.value || '');
    }

    function mirror(source) {
      // Sync checked/value state onto the matching input in the *other*
      // rendered copy of the form (desktop sidebar vs mobile drawer). Visual
      // "is-selected" styling is handled separately in syncChipStyles(),
      // which runs for every input in every form — including the one the
      // user actually clicked — so a swatch/chip always reflects its own
      // state instead of relying on being "the other" element.
      var k = key(source);
      forms.forEach(function (form) {
        form.querySelectorAll('[data-filter-input]').forEach(function (input) {
          if (input === source || key(input) !== k) return;
          if (input.type === 'checkbox') {
            input.checked = source.checked;
          } else {
            input.value = source.value;
          }
        });
      });
    }

    function syncChipStyles() {
      document.querySelectorAll('.filter-chip, .filter-swatch').forEach(function (label) {
        var input = label.querySelector('[data-filter-input]');
        if (input) label.classList.toggle('is-selected', input.checked);
      });
    }

    function collect(group) {
      var values = [];
      forms[0].querySelectorAll('[data-filter-group="' + group + '"]:checked').forEach(function (el) {
        values.push(el.value);
      });
      return values;
    }

    function apply() {
      var available = forms[0].querySelector('[data-filter-group="available"]');
      var wantAvailable = available && available.checked;
      var priceMinEl = forms[0].querySelector('[data-filter-group="price-min"]');
      var priceMaxEl = forms[0].querySelector('[data-filter-group="price-max"]');
      var priceMin = priceMinEl && priceMinEl.value !== '' ? parseFloat(priceMinEl.value) * 100 : null;
      var priceMax = priceMaxEl && priceMaxEl.value !== '' ? parseFloat(priceMaxEl.value) * 100 : null;
      var types = collect('type');
      var sizes = collect('size');
      var colors = collect('color');
      var discounts = collect('discount');
      var visibleCount = 0;

      cards.forEach(function (card) {
        var ok = true;
        if (wantAvailable && card.dataset.available !== '1') ok = false;
        if (ok && priceMin !== null && parseFloat(card.dataset.price) < priceMin) ok = false;
        if (ok && priceMax !== null && parseFloat(card.dataset.price) > priceMax) ok = false;
        if (ok && types.length && types.indexOf(card.dataset.type) === -1) ok = false;
        if (ok && discounts.length) {
          // Each range is "min-max": matches min < discount <= max.
          var cardDiscount = parseFloat(card.dataset.discount) || 0;
          if (!discounts.some(function (range) {
            var bounds = range.split('-');
            return cardDiscount > Number(bounds[0]) && cardDiscount <= Number(bounds[1]);
          })) ok = false;
        }
        if (ok && sizes.length) {
          var cardSizes = (card.dataset.sizes || '').split(' ');
          if (!sizes.some(function (s) { return cardSizes.indexOf(s) !== -1; })) ok = false;
        }
        if (ok && colors.length) {
          var cardColors = (card.dataset.colors || '').split(' ');
          if (!colors.some(function (c) { return cardColors.indexOf(c) !== -1; })) ok = false;
        }
        card.style.display = ok ? '' : 'none';
        if (ok) visibleCount++;
      });

      document.querySelectorAll('[data-filters-empty]').forEach(function (msg) {
        msg.hidden = visibleCount !== 0;
      });

      // Product count in the toolbar and on the Apply Filters buttons: the
      // matching products while a filter is on, else the collection total
      // the page was rendered with (which also counts other pages).
      var filtering = wantAvailable || priceMin !== null || priceMax !== null ||
        types.length > 0 || sizes.length > 0 || colors.length > 0 || discounts.length > 0;
      document.querySelectorAll('[data-filter-count]').forEach(function (el) {
        if (!el.hasAttribute('data-filter-total')) el.setAttribute('data-filter-total', el.textContent);
        el.textContent = filtering ? visibleCount : el.getAttribute('data-filter-total');
      });

      syncChipStyles();
    }

    forms.forEach(function (form) {
      form.querySelectorAll('[data-filter-input]').forEach(function (input) {
        input.addEventListener('change', function () { mirror(input); apply(); });
        if (input.type === 'number') {
          input.addEventListener('input', function () { mirror(input); apply(); });
        }
      });
      var clearBtn = form.querySelector('[data-filters-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', function () {
          forms.forEach(function (f) {
            f.querySelectorAll('[data-filter-input]').forEach(function (input) {
              if (input.type === 'checkbox') {
                input.checked = false;
              } else {
                input.value = '';
              }
            });
          });
          apply();
        });
      }
    });

    apply();
  }
  function initCategoryExplorer() {
    // Phone "Categories | Products" tabs on collection pages. The rail and tiles
    // come from the header menu (nuvi-category-rail.liquid renders them into a
    // <template>); with no menu items there is nothing to show, so the tabs stay
    // hidden and the page is the normal Products view.
    var views = document.querySelector('[data-collection-views]');
    if (!views || views.hasAttribute('data-views-off')) return;
    var tabs = views.querySelector('[data-collection-view-tabs]');
    var slot = views.querySelector('[data-category-explorer-slot]');
    var source = document.querySelector('template[data-category-rail-source]');
    if (!tabs || !slot || !source) return;
    slot.appendChild(source.content.cloneNode(true));
    tabs.hidden = false;

    var viewTabs = Array.prototype.slice.call(tabs.querySelectorAll('[data-view-tab]'));
    var setView = function (view, remember) {
      if (view !== 'categories') view = 'products';
      views.setAttribute('data-view', view);
      viewTabs.forEach(function (t) {
        t.setAttribute('aria-selected', t.getAttribute('data-view-tab') === view ? 'true' : 'false');
      });
      if (remember && window.history && window.history.replaceState) {
        // So Back from a tapped tile returns to the tab the shopper left.
        try {
          var state = Object.assign({}, window.history.state || {}, { nuviCollectionView: view });
          window.history.replaceState(state, '');
        } catch (e) { /* ignore */ }
      }
    };
    var saved = window.history && window.history.state && window.history.state.nuviCollectionView;
    setView(saved || views.getAttribute('data-default-view'), false);
    viewTabs.forEach(function (t) {
      t.addEventListener('click', function () {
        setView(t.getAttribute('data-view-tab'), true);
        var top = tabs.getBoundingClientRect().top + window.pageYOffset - (parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--nuvi-header-h')) || 0) - 8;
        if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top));
      });
    });

    var railTabs = Array.prototype.slice.call(slot.querySelectorAll('[data-category-tab]'));
    var panes = Array.prototype.slice.call(slot.querySelectorAll('[data-category-pane]'));
    var selectItem = function (index, focus) {
      railTabs.forEach(function (t) {
        var on = t.getAttribute('data-category-tab') === String(index);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) t.focus();
      });
      panes.forEach(function (p) {
        var on = p.getAttribute('data-category-pane') === String(index);
        p.hidden = !on;
        if (on) p.scrollTop = 0;
      });
    };
    railTabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectItem(t.getAttribute('data-category-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = railTabs[(i + 1) % railTabs.length];
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = railTabs[(i - 1 + railTabs.length) % railTabs.length];
        else if (e.key === 'Home') next = railTabs[0];
        else if (e.key === 'End') next = railTabs[railTabs.length - 1];
        if (next) { e.preventDefault(); selectItem(next.getAttribute('data-category-tab'), true); }
      });
    });

    // Bring the opened rail item into view (e.g. Footwear near the bottom).
    var rail = slot.querySelector('.category-explorer__rail');
    var active = slot.querySelector('[data-category-tab][aria-selected="true"]');
    if (rail && active && rail.scrollHeight > rail.clientHeight) {
      rail.scrollTop = Math.max(0, active.offsetTop - (rail.clientHeight - active.offsetHeight) / 2);
    }
  }

  function initSubcategoryBubbles() {
    // Copies the subcategory row (rendered by nuvi-header from the menu item that
    // links to this collection, see nuvi-subcategory-bubbles.liquid) into the
    // collection page's slot. No slot (hidden collection) or no menu match = no row.
    var slot = document.querySelector('[data-subcategory-slot]');
    var source = document.querySelector('template[data-subcategory-source]');
    if (!slot || !source) return;
    slot.appendChild(source.content.cloneNode(true));

    // On a subcategory page, scroll the row so the highlighted circle is in view.
    var track = slot.querySelector('.subcategory-bubbles__track');
    var current = slot.querySelector('[aria-current="page"]');
    var centerCurrent = function () {
      if (track && current && track.scrollWidth > track.clientWidth) {
        track.scrollLeft = Math.max(0, current.offsetLeft - track.offsetLeft - (track.clientWidth - current.offsetWidth) / 2);
      }
    };
    centerCurrent();
    if (!track) return;

    // The slot is CSS-sticky under the header; once it reaches the header it
    // shrinks to pill chips (.is-stuck). A marker just above the slot tells us
    // when that happens, since the slot's own position no longer moves while
    // stuck. The height it loses goes back as margin so the grid doesn't jump.
    var marker = document.createElement('div');
    marker.setAttribute('aria-hidden', 'true');
    slot.parentNode.insertBefore(marker, slot);
    var stuck = false;
    var ticking = false;
    var root = document.documentElement;

    var setStuck = function (next) {
      if (next === stuck) return;
      stuck = next;
      if (next) {
        var fullH = slot.offsetHeight;
        slot.classList.add('is-stuck');
        var compactH = slot.offsetHeight;
        slot.style.marginBottom = (fullH - compactH) + 'px';
        root.style.setProperty('--nuvi-subcat-h', compactH + 'px');
      } else {
        slot.classList.remove('is-stuck');
        slot.style.marginBottom = '';
        root.style.removeProperty('--nuvi-subcat-h');
      }
      centerCurrent();
    };

    var update = function () {
      var top = parseFloat(window.getComputedStyle(slot).top) || 0;
      setStuck(marker.getBoundingClientRect().top < top - 1);
      ticking = false;
    };
    var onScroll = function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }
  function initSortForm() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  /* ======================================================
     12. CAROUSELS (reviews + category rail)
     ====================================================== */
  function initReviewsCarousel() {
    document.querySelectorAll('[data-reviews-carousel]').forEach(function (carousel) {
      var cards = carousel.querySelectorAll('[data-review-card]');
      var dots = carousel.parentElement.querySelectorAll('[data-reviews-dot]');
      var prevBtn = carousel.parentElement.querySelector('[data-reviews-prev]');
      var nextBtn = carousel.parentElement.querySelector('[data-reviews-next]');
      if (cards.length <= 1) return;
      var index = 0, timer;
      function show(i) {
        index = (i + cards.length) % cards.length;
        cards.forEach(function (c, idx) { c.classList.toggle('is-active', idx === index); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === index); });
      }
      function next() { show(index + 1); }
      function restart() { clearInterval(timer); timer = setInterval(next, 6000); }
      prevBtn && prevBtn.addEventListener('click', function () { show(index - 1); restart(); });
      nextBtn && nextBtn.addEventListener('click', function () { show(index + 1); restart(); });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); restart(); }); });
      restart();
    });
  }
  function localIsoDate(date) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  }

  // Liquid already skips coupons outside their dates, but a cached page can
  // outlive an end date: drop those cards (and their dots) here too.
  function dropOutOfDateCoupons(strip, today) {
    strip.querySelectorAll('[data-coupon-slide]').forEach(function (slide) {
      var starts = slide.getAttribute('data-coupon-starts');
      var ends = slide.getAttribute('data-coupon-ends');
      if ((starts && starts > today) || (ends && ends < today)) slide.remove();
    });
    var left = strip.querySelectorAll('[data-coupon-slide]').length;
    if (!left) { strip.remove(); return false; }
    var dotsWrap = strip.querySelector('[data-coupon-dots]');
    if (dotsWrap) {
      var dots = dotsWrap.querySelectorAll('button');
      if (left <= 1) {
        dotsWrap.remove();
      } else {
        for (var i = left; i < dots.length; i++) dots[i].remove();
      }
    }
    return true;
  }

  // Explore, Shop & Save coupons: tapping a code copies it. Delegated from the
  // document so it keeps working when the theme editor re-renders the section.
  function initExploreShopSave() {
    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-ess-copy]');
      if (!btn) return;
      var code = btn.dataset.essCopy;
      var label = btn.querySelector('[data-ess-copy-label]') || btn;
      var status = btn.closest('[data-ess-coupons]');
      status = status && status.querySelector('[data-ess-copy-status]');
      function done() {
        label.textContent = 'Copied!';
        btn.classList.add('is-copied');
        if (status) status.textContent = 'Code ' + code + ' copied';
        clearTimeout(btn._essTimer);
        btn._essTimer = setTimeout(function () {
          label.textContent = 'Code: ' + code;
          btn.classList.remove('is-copied');
        }, 1600);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        done();
      }
    });
  }

  // Product page coupons: one card at a time, sliding to the next every few
  // seconds like a swipe. Shoppers can also swipe or tap the dots; it pauses
  // while hovered, focused or touched.
  function initCouponCarousel() {
    var today = localIsoDate(new Date());
    document.querySelectorAll('[data-coupon-carousel]').forEach(function (strip) {
      if (!dropOutOfDateCoupons(strip, today)) return;
      var track = strip.querySelector('[data-coupon-track]');
      var slides = strip.querySelectorAll('[data-coupon-slide]');
      var dots = strip.querySelectorAll('[data-coupon-dots] button');
      var index = 0, paused = false;

      strip.querySelectorAll('[data-coupon-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var code = btn.dataset.couponCopy;
          function done() { btn.textContent = 'Copied'; setTimeout(function () { btn.textContent = 'Copy'; }, 1500); }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done, done);
          } else {
            done();
          }
        });
      });

      if (slides.length <= 1) return;
      function show(i) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }
      track.addEventListener('scroll', function () {
        index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === index)); });
      }, { passive: true });
      dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); });
      ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        strip.addEventListener(ev, function () { paused = true; }, { passive: true });
      });
      ['mouseleave', 'focusout', 'touchend'].forEach(function (ev) {
        strip.addEventListener(ev, function () { paused = false; }, { passive: true });
      });
      setInterval(function () {
        if (!paused && !document.hidden) show(index + 1);
      }, 3500);
    });
  }
  /* ======================================================
     PIN CODE DELIVERY CHECKER (snippets/nuvi-delivery-checker.liquid)
     Asks the store's own delivery endpoint (app proxy / backend that holds
     the courier credentials) and shows only what it confirms. No endpoint,
     a bad answer or a network failure all end in the same "can't check
     right now" message: never a made-up date, fee or COD promise.
     ====================================================== */
  var DELIVERY_PIN_KEY = 'nuvi:delivery-pin';
  var DELIVERY_TIMEOUT_MS = 8000;
  var deliveryListenersBound = false;

  // Indian PIN codes: six digits, never starting with 0.
  function isValidPincode(pin) {
    return typeof pin === 'string' && /^[1-9][0-9]{5}$/.test(pin);
  }

  // Same-origin path ("/apps/delivery/check") or an https URL; anything else
  // (blank, javascript:, protocol-relative) leaves the checker unconfigured.
  function deliveryCheckUrl(endpoint, params, base) {
    var raw = String(endpoint || '').trim();
    if (!raw) return null;
    if (!/^\/(?!\/)/.test(raw) && !/^https:\/\//i.test(raw)) return null;
    var url;
    try { url = new URL(raw, base || window.location.href); } catch (err) { return null; }
    Object.keys(params || {}).forEach(function (key) {
      if (params[key] != null && params[key] !== '') url.searchParams.set(key, params[key]);
    });
    return url;
  }

  function isoDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    var parts = value.split('-').map(Number);
    var date = new Date(parts[0], parts[1] - 1, parts[2]);
    return date.getMonth() === parts[1] - 1 ? date : null;
  }

  function wholeDays(value) {
    return typeof value === 'number' && Math.floor(value) === value && value >= 0 && value <= 60;
  }

  function delhiveryFlag(value) {
    var v = typeof value === 'string' ? value.trim().toUpperCase() : '';
    return v === 'Y' ? true : v === 'N' ? false : null;
  }

  // Delhivery's pin-codes API body, passed through unchanged by the proxy:
  //   { "delivery_codes": [{ "postal_code": { "pin": 560066, "pre_paid": "Y", "cod": "N", "remarks": "" } }] }
  // An empty list is Delhivery's "not serviceable", and so is an embargoed PIN.
  function parseDelhiveryResponse(json, pin) {
    var unavailable = { kind: 'unavailable', pincode: pin };
    var codes = json.delivery_codes;
    if (!codes.length) return { kind: 'no', pincode: pin };
    var entry = null;
    codes.forEach(function (code) {
      var postal = code && code.postal_code;
      if (!entry && postal && typeof postal === 'object' && String(postal.pin) === pin) entry = postal;
    });
    if (!entry) return unavailable;
    if (/embargo/i.test(String(entry.remarks || ''))) return { kind: 'no', pincode: pin };
    var prepaid = delhiveryFlag(entry.pre_paid);
    var cod = delhiveryFlag(entry.cod);
    if (prepaid === null && cod === null) return unavailable;
    if (prepaid !== true && cod !== true) return { kind: 'no', pincode: pin };
    var result = { kind: 'ok', pincode: pin };
    if (prepaid !== null) result.prepaid = prepaid;
    if (cod !== null) result.cod = cod;
    return result;
  }

  // Reads the endpoint's JSON for `pin`. Returns { kind: 'ok' | 'no' | 'unavailable' }
  // plus the optional fields it could verify; anything malformed is dropped.
  function parseDeliveryResponse(json, pin) {
    var unavailable = { kind: 'unavailable', pincode: pin };
    if (!json || typeof json !== 'object') return unavailable;
    if (Array.isArray(json.delivery_codes)) return parseDelhiveryResponse(json, pin);
    if (json.status !== 'ok' || typeof json.serviceable !== 'boolean') return unavailable;
    if (json.pincode != null && String(json.pincode) !== pin) return unavailable;
    if (!json.serviceable) return { kind: 'no', pincode: pin };

    var result = { kind: 'ok', pincode: pin };
    var estimate = json.estimate;
    if (estimate && typeof estimate === 'object') {
      var earliest = isoDate(estimate.earliest_date);
      var latest = isoDate(estimate.latest_date) || earliest;
      if (earliest && latest >= earliest) {
        result.earliest = earliest;
        result.latest = latest;
      } else if (wholeDays(estimate.min_days) && wholeDays(estimate.max_days) && estimate.max_days >= estimate.min_days && estimate.max_days > 0) {
        result.minDays = estimate.min_days;
        result.maxDays = estimate.max_days;
      }
    }
    var shipping = json.shipping;
    if (shipping && typeof shipping === 'object' && typeof shipping.amount === 'number' &&
        Math.floor(shipping.amount) === shipping.amount && shipping.amount >= 0 &&
        typeof shipping.currency === 'string' && /^[A-Z]{3}$/.test(shipping.currency)) {
      result.shipping = { amount: shipping.amount, currency: shipping.currency };
    }
    if (typeof json.prepaid_available === 'boolean') result.prepaid = json.prepaid_available;
    if (typeof json.cod_available === 'boolean') result.cod = json.cod_available;
    return result;
  }

  function formatDeliveryDate(date) {
    try {
      return date.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (err) {
      return date.toDateString();
    }
  }

  function formatShippingFee(shipping) {
    if (shipping.amount === 0) return 'Free';
    var active = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    if (!active || active === shipping.currency) return formatMoney(shipping.amount);
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: shipping.currency }).format(shipping.amount / 100);
    } catch (err) {
      return shipping.currency + ' ' + (shipping.amount / 100).toFixed(2);
    }
  }

  function deliveryResultHtml(result) {
    if (result.kind === 'invalid') {
      return '<p class="delivery-check__line">Please enter a valid 6-digit PIN code.</p>';
    }
    if (result.kind === 'unavailable') {
      return '<p class="delivery-check__line">Unable to check delivery availability. Please try again.</p>';
    }
    if (result.kind === 'no') {
      return '<p class="delivery-check__line delivery-check__line--strong">Sorry, delivery is currently unavailable to this PIN code.</p>' +
        '<button type="button" class="delivery-check__change" data-delivery-check-change>Try another PIN code</button>';
    }
    var rows = [];
    if (result.earliest) {
      var same = result.latest.getTime() === result.earliest.getTime();
      rows.push('<li><span>Estimated delivery</span><strong>' + escapeHtml(formatDeliveryDate(result.earliest)) +
        (same ? '' : ' &ndash; ' + escapeHtml(formatDeliveryDate(result.latest))) + '</strong></li>');
    } else if (result.maxDays) {
      var days = result.minDays === result.maxDays ? String(result.maxDays) : result.minDays + '&ndash;' + result.maxDays;
      rows.push('<li><span>Estimated delivery</span><strong>' + days + ' day' + (result.maxDays === 1 ? '' : 's') + '</strong></li>');
    }
    if (result.shipping) {
      rows.push('<li><span>Shipping</span><strong>' + escapeHtml(formatShippingFee(result.shipping)) + '</strong></li>');
    }
    if (typeof result.prepaid === 'boolean') {
      rows.push('<li><span>Prepaid (pay online)</span><strong>' + (result.prepaid ? 'Available' : 'Not available') + '</strong></li>');
    }
    if (typeof result.cod === 'boolean') {
      rows.push('<li><span>Cash on delivery</span><strong>' + (result.cod ? 'Available' : 'Not available') + '</strong></li>');
    }
    return '<p class="delivery-check__line delivery-check__line--strong">' +
        '<span class="delivery-check__tick" aria-hidden="true"></span>Great news! Delivery is available to your location.' +
        ' <button type="button" class="delivery-check__change" data-delivery-check-change>Change</button></p>' +
      (rows.length ? '<ul class="delivery-check__facts">' + rows.join('') + '</ul>' : '') +
      '<p class="delivery-check__note">Final delivery date and charges are confirmed at checkout.</p>';
  }

  function bindDeliveryChecker(root) {
    if (root.__nuviDeliveryCheck) return;
    var form = root.querySelector('[data-delivery-check-form]');
    var input = root.querySelector('[data-delivery-check-input]');
    var submit = root.querySelector('[data-delivery-check-submit]');
    var label = root.querySelector('[data-delivery-check-label]');
    var output = root.querySelector('[data-delivery-check-result]');
    if (!form || !input || !submit || !output) return;

    var seq = 0;
    var controller = null;
    var pending = null; // { pin, variantId } of the request in flight
    var shown = null;   // { pin, variantId, kind } of the result on screen

    function currentVariantId() {
      var hidden = document.querySelector('#ProductForm [data-product-variant-id]');
      return (hidden && hidden.value) || root.dataset.variantId || '';
    }

    function currentQuantity() {
      var qty = document.querySelector('#ProductForm [data-qty-input]');
      var n = qty ? parseInt(qty.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    function setLoading(on) {
      root.classList.toggle('is-loading', on);
      submit.setAttribute('aria-busy', String(on));
      if (label) label.textContent = on ? 'Checking' : 'Check';
    }

    function show(result, variantId) {
      root.dataset.state = result.kind;
      input.setAttribute('aria-invalid', String(result.kind === 'invalid'));
      output.innerHTML = deliveryResultHtml(result);
      shown = result.kind === 'invalid' ? null : { pin: result.pincode, variantId: variantId, kind: result.kind };
    }

    function clear() {
      seq++;
      if (controller) controller.abort();
      controller = null;
      pending = null;
      shown = null;
      setLoading(false);
      root.removeAttribute('data-state');
      input.setAttribute('aria-invalid', 'false');
      output.innerHTML = '';
    }

    function check(pin) {
      if (!isValidPincode(pin)) {
        clear();
        show({ kind: 'invalid', pincode: pin }, '');
        return;
      }
      var variantId = currentVariantId();
      // Same question already being answered: ignore the repeat click.
      if (pending && pending.pin === pin && pending.variantId === variantId) return;
      clear();
      try { localStorage.setItem(DELIVERY_PIN_KEY, pin); } catch (err) { /* storage blocked */ }

      var url = deliveryCheckUrl(root.dataset.endpoint, {
        pincode: pin,
        filter_codes: pin, // Delhivery's own parameter name, for a pass-through proxy
        product_id: root.dataset.productId,
        variant_id: variantId,
        quantity: currentQuantity()
      });
      if (!url || typeof fetch !== 'function') {
        show({ kind: 'unavailable', pincode: pin }, variantId);
        return;
      }

      var mine = ++seq;
      var abort = typeof AbortController === 'function' ? new AbortController() : null;
      controller = abort;
      pending = { pin: pin, variantId: variantId };
      setLoading(true);
      var timer = setTimeout(function () { if (abort) abort.abort(); }, DELIVERY_TIMEOUT_MS);

      fetch(url.toString(), {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: url.origin === window.location.origin ? 'same-origin' : 'omit',
        signal: abort ? abort.signal : undefined
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (json) { return parseDeliveryResponse(json, pin); },
              function () { return { kind: 'unavailable', pincode: pin }; })
        .then(function (result) {
          clearTimeout(timer);
          if (mine !== seq) return; // a newer check (or an edit) replaced this one
          controller = null;
          pending = null;
          setLoading(false);
          show(result, variantId);
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      check(input.value.trim());
    });

    input.addEventListener('input', function () {
      var digits = input.value.replace(/\D/g, '').slice(0, 6);
      if (digits !== input.value) input.value = digits;
      // Editing the PIN makes the answer on screen (or on its way) stale.
      if ((shown && shown.pin !== digits) || (pending && pending.pin !== digits) || root.dataset.state === 'invalid') clear();
    });

    output.addEventListener('click', function (e) {
      if (!e.target.closest('[data-delivery-check-change]')) return;
      clear();
      input.focus();
      input.select();
    });

    root.__nuviDeliveryCheck = {
      // A different size/colour can ship from elsewhere: re-ask for the PIN on screen.
      onVariantChange: function (variant) {
        if (variant && variant.id) root.dataset.variantId = variant.id;
        if (shown && shown.kind !== 'unavailable' && shown.variantId !== String(currentVariantId())) check(shown.pin);
      }
    };

    try {
      var saved = localStorage.getItem(DELIVERY_PIN_KEY);
      if (isValidPincode(saved) && !input.value) input.value = saved;
    } catch (err) { /* storage blocked */ }
  }

  function initDeliveryChecker(scope) {
    (scope || document).querySelectorAll('[data-delivery-check]').forEach(bindDeliveryChecker);
    if (deliveryListenersBound) return;
    deliveryListenersBound = true;
    document.addEventListener('nuvi:variant-change', function (e) {
      document.querySelectorAll('[data-delivery-check]').forEach(function (root) {
        if (root.__nuviDeliveryCheck) root.__nuviDeliveryCheck.onVariantChange(e.detail && e.detail.variant);
      });
    });
    // Theme editor re-renders a section in place: bind the fresh markup.
    document.addEventListener('shopify:section-load', function (e) {
      if (e.target && e.target.querySelectorAll) initDeliveryChecker(e.target);
    });
  }

  function initStoreLocatorCarousel() {
    document.querySelectorAll('[data-store-carousel]').forEach(function (carousel) {
      var photos = carousel.querySelectorAll('[data-store-photo]');
      var dots = carousel.querySelectorAll('[data-store-dot]');
      if (photos.length <= 1) return;
      var index = 0;
      function show(i) {
        index = (i + photos.length) % photos.length;
        photos.forEach(function (p, idx) { p.classList.toggle('is-active', idx === index); });
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === index); });
      }
      setInterval(function () { show(index + 1); }, 4000);
    });
  }
  // Shop by occasion carousel: arrows scroll the rail one "page" of cards and
  // grey out at either end. Delegated from the document so it keeps working
  // when the theme editor re-renders the section.
  function initShopByOccasion() {
    function sync(carousel) {
      var rail = carousel.querySelector('[data-sbo-rail]');
      if (!rail) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var scrollable = max > 2;
      carousel.classList.toggle('is-scrollable', scrollable);
      var prev = carousel.querySelector('[data-sbo-prev]');
      var next = carousel.querySelector('[data-sbo-next]');
      if (prev) prev.setAttribute('aria-disabled', String(!scrollable || rail.scrollLeft <= 2));
      if (next) next.setAttribute('aria-disabled', String(!scrollable || rail.scrollLeft >= max - 2));
    }
    function syncAll() {
      document.querySelectorAll('[data-sbo-carousel]').forEach(sync);
    }
    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-sbo-prev], [data-sbo-next]');
      if (!btn) return;
      var carousel = btn.closest('[data-sbo-carousel]');
      var rail = carousel && carousel.querySelector('[data-sbo-rail]');
      if (!rail || btn.getAttribute('aria-disabled') === 'true') return;
      var dir = btn.hasAttribute('data-sbo-next') ? 1 : -1;
      var item = rail.querySelector('.sbo-carousel__item');
      var step = item ? item.getBoundingClientRect().width : rail.clientWidth / 2;
      var perPage = Math.max(1, Math.floor((rail.clientWidth + 8) / (step + 8)) - 1);
      rail.scrollBy({ left: dir * perPage * (step + 8), behavior: 'smooth' });
    });
    document.addEventListener('scroll', function (event) {
      var rail = event.target;
      if (rail && rail.matches && rail.matches('[data-sbo-rail]')) sync(rail.closest('[data-sbo-carousel]'));
    }, true);
    window.addEventListener('resize', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
    syncAll();
  }

  function initCategoryOrbit() {
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.category-orbit').forEach(function (section) {
      var rail = section.querySelector('[data-orbit-rail]');
      var track = rail && rail.querySelector('.orbit-track');
      var prevBtn = section.querySelector('[data-orbit-prev]');
      var nextBtn = section.querySelector('[data-orbit-next]');
      if (!rail || !track) return;

      // Clicking an arrow while the auto-scroll ticker is running needs to
      // pause it first - otherwise the ticker overwrites scrollLeft again
      // on the very next frame and the smooth-scroll jump is invisible.
      var resumeTimer;
      function nudge(amount) {
        paused = true;
        rail.scrollBy({ left: amount, behavior: 'smooth' });
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () { paused = false; }, 650);
      }
      prevBtn && prevBtn.addEventListener('click', function () { nudge(-240); });
      nextBtn && nextBtn.addEventListener('click', function () { nudge(240); });

      // Auto-scroll only kicks in when items actually overflow the rail
      // (i.e. something would otherwise be cropped), and never on mobile
      // (<640px) - there it's always a plain, user-driven swipe strip,
      // arrows included (those are hidden by CSS on mobile too).
      // Driven by nudging scrollLeft on every frame rather than a CSS
      // transform, so the arrow buttons keep working normally at the
      // same time instead of being hidden while it plays.
      var originalHtml = track.innerHTML;
      var rafId = null;
      var lastTs = null;
      var paused = false;
      var LOOP_SECONDS = 70;

      function tick(ts) {
        if (lastTs === null) lastTs = ts;
        var dt = ts - lastTs;
        lastTs = ts;
        if (!paused) {
          var half = track.scrollWidth / 2;
          var pxPerSecond = half / LOOP_SECONDS;
          rail.scrollLeft += pxPerSecond * (dt / 1000);
          if (rail.scrollLeft >= half) rail.scrollLeft -= half;
        }
        rafId = requestAnimationFrame(tick);
      }

      function stopAutoScroll() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = null;
        lastTs = null;
        rail.classList.remove('orbit-rail--marquee');
      }

      function startAutoScroll() {
        rail.classList.add('orbit-rail--marquee');
        lastTs = null;
        if (!rafId) rafId = requestAnimationFrame(tick);
      }

      function evaluateOverflow() {
        stopAutoScroll();
        track.innerHTML = originalHtml;
        var isMobile = window.innerWidth < 640;
        var overflowing = track.scrollWidth > rail.clientWidth + 1;
        // Arrows only ever appear together with the auto-scroll motion -
        // if everything already fits, there's nothing to scroll to, so
        // both stay hidden.
        var showControls = overflowing && !isMobile;
        if (prevBtn) prevBtn.classList.toggle('is-hidden', !showControls);
        if (nextBtn) nextBtn.classList.toggle('is-hidden', !showControls);
        if (showControls && !prefersReducedMotion) {
          // The second copy only exists for the seamless loop - hide it from
          // screen readers and keyboard focus so items aren't announced twice.
          track.innerHTML = originalHtml + '<div class="marquee-clone" aria-hidden="true" inert>' + originalHtml + '</div>';
          startAutoScroll();
        }
      }

      rail.addEventListener('mouseenter', function () { paused = true; });
      rail.addEventListener('mouseleave', function () { paused = false; });

      evaluateOverflow();
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(evaluateOverflow, 200);
      });
    });
  }

  /* ======================================================
     13. WISHLIST (client-side, localStorage — no app required)
     ====================================================== */
  var WISHLIST_KEY = 'nuvi:wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('nuvi:wishlist-change', { detail: { items: items } }));
  }

  function toggleWishlist(productId, productHandle, originEl) {
    var items = getWishlist();
    var exists = items.some(function (item) { return String(item.id) === String(productId); });
    if (exists) {
      items = items.filter(function (item) { return String(item.id) !== String(productId); });
    } else {
      items.push({ id: productId, handle: productHandle, addedAt: Date.now() });
    }
    setWishlist(items);
    if (originEl && !exists) {
      originEl.classList.add('is-bouncing');
      setTimeout(function () { originEl.classList.remove('is-bouncing'); }, 400);
    }
    return !exists;
  }

  function refreshWishlistButtons() {
    var items = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.dataset.productId;
      var active = items.some(function (item) { return String(item.id) === String(id); });
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? 'Saved to Wishlist' : 'Add to Wishlist';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = items.length;
      el.classList.toggle('is-hidden', items.length === 0);
    });
  }

  function buildWishlistCard(product) {
    var a = document.createElement('a');
    a.href = '/products/' + encodeURIComponent(product.handle);
    a.className = 'product-card';
    var image = product.featured_image
      ? '<img class="product-card__image product-card__image--primary" src="' + escapeHtml(product.featured_image) + '" alt="' + escapeHtml(product.title) + '" width="600" height="750" loading="lazy">'
      : '<div class="wishlist-card__placeholder"></div>';
    var price = formatMoney(product.price);
    a.innerHTML =
      '<div class="product-card__media">' + image + '</div>' +
      '<div class="product-card__info"><div><span class="product-card__title">' + escapeHtml(product.title) + '</span></div>' +
      '<div class="product-card__price"><span class="nuvi-price__now">' + escapeHtml(price) + '</span></div></div>';
    return a;
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var items = getWishlist();
    var emptyState = document.querySelector('[data-wishlist-empty]');

    if (items.length === 0) {
      grid.hidden = true;
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;
    grid.hidden = false;

    grid.innerHTML = '';
    items.forEach(function (item) {
      if (!item || !isValidHandle(item.handle)) return;
      fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return;
          grid.appendChild(buildWishlistCard(product));
        })
        .catch(function () {});
    });
  }

  /* ---------- product page: tabs, SKU, photo zoom ---------- */
  function initProductPageExtras() {
    var tabs = document.querySelector('[data-pdp-tabs]');
    function selectTab(name) {
      if (!tabs) return;
      tabs.querySelectorAll('[data-pdp-tab]').forEach(function (tab) {
        tab.setAttribute('aria-selected', String(tab.dataset.pdpTab === name));
      });
      tabs.querySelectorAll('[data-pdp-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.pdpPanel !== name;
      });
    }
    if (tabs) {
      tabs.addEventListener('click', function (e) {
        var tab = e.target.closest('[data-pdp-tab]');
        if (tab) selectTab(tab.dataset.pdpTab);
      });
      tabs.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var list = Array.prototype.slice.call(tabs.querySelectorAll('[data-pdp-tab]'));
        var i = list.indexOf(document.activeElement);
        if (i < 0) return;
        var next = list[(i + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
        next.focus();
        selectTab(next.dataset.pdpTab);
      });
    }

    // SKU line follows the chosen variant (hidden when that variant has none).
    var sku = document.querySelector('[data-variant-sku]');
    if (sku) {
      document.addEventListener('nuvi:variant-change', function (e) {
        var variant = e.detail && e.detail.variant;
        if (!variant) return;
        sku.textContent = variant.sku || '';
        sku.hidden = !variant.sku;
      });
    }

    // Expand button: the current photo, large, in a dialog.
    var zoomBtn = document.querySelector('[data-gallery-zoom]');
    var dialog = document.querySelector('[data-gallery-zoom-dialog]');
    if (zoomBtn && dialog && typeof dialog.showModal === 'function') {
      var zoomImg = dialog.querySelector('[data-gallery-zoom-img]');
      zoomBtn.addEventListener('click', function () {
        var img = document.querySelector('[data-gallery-slide].is-active img');
        if (!img || !zoomImg) return;
        var src = img.currentSrc || img.src;
        zoomImg.src = src.replace(/([?&])width=\d+/, '$1width=2000');
        zoomImg.alt = img.alt || '';
        dialog.showModal();
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-gallery-zoom-close]')) dialog.close();
      });
    } else if (zoomBtn) {
      zoomBtn.hidden = true;
    }
  }

  function initWishlist() {
    refreshWishlistButtons();
    document.body.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(btn.dataset.productId, btn.dataset.productHandle, btn);
      refreshWishlistButtons();
    });
    document.addEventListener('nuvi:wishlist-change', refreshWishlistButtons);
    renderWishlistPage();
  }

  /* ======================================================
     14. STICKY ADD TO CART (product page)
     ====================================================== */
  function initStickyAddToCart() {
    var bar = document.querySelector('[data-sticky-atc]');
    var trigger = document.querySelector('[data-add-to-cart]');
    if (!bar || !trigger) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Only show the sticky bar once the real button has scrolled ABOVE
        // the viewport (boundingClientRect.top < 0) — not merely whenever
        // it's off-screen, which is also true before the user has scrolled
        // down to it yet (e.g. right on page load).
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        document.body.classList.toggle('has-sticky-atc', scrolledPast);
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    observer.observe(trigger);

    var stickyBtn = bar.querySelector('[data-sticky-add-to-cart]');
    stickyBtn && stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var form = document.getElementById('ProductForm');
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  /* ======================================================
     15. RECENTLY VIEWED PRODUCTS
     ====================================================== */
  var RECENTLY_VIEWED_KEY = 'nuvi:recently-viewed';
  var MAX_RECENTLY_VIEWED = 12;

  function trackRecentlyViewed() {
    var jsonScript = document.querySelector('[data-product-json]');
    if (!jsonScript) return;
    var product;
    try { product = JSON.parse(jsonScript.textContent); } catch (e) { return; }
    if (!product || !product.handle) return;

    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) {}
    list = list.filter(function (h) { return h !== product.handle; });
    list.unshift(product.handle);
    list = list.slice(0, MAX_RECENTLY_VIEWED);
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(list));
  }

  function renderRecentlyViewed() {
    var rail = document.querySelector('[data-recently-viewed-rail]');
    if (!rail) return;
    var currentHandle = null;
    var jsonScript = document.querySelector('[data-product-json]');
    if (jsonScript) {
      try { currentHandle = JSON.parse(jsonScript.textContent).handle; } catch (e) {}
    }

    var list = [];
    try { list = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || []; } catch (e) {}
    list = list.filter(function (h) { return isValidHandle(h) && h !== currentHandle; }).slice(0, 8);

    var section = rail.closest('[data-recently-viewed-section]');
    if (list.length === 0) {
      if (section) section.hidden = true;
      return;
    }
    if (section) section.hidden = false;

    rail.innerHTML = '';
    list.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) return;
          rail.appendChild(buildWishlistCard(product));
        })
        .catch(function () {});
    });
  }

  /* ======================================================
     16. SIZE GUIDE MODAL
     ====================================================== */
  function initSizeGuide() {
    var trigger = document.querySelector('[data-size-guide]');
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!trigger || !modal) return;

    var closeBtns = modal.querySelectorAll('[data-size-guide-close]');
    var overlay = modal.querySelector('[data-size-guide-overlay]');

    function open() {
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
    }
    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 300);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    overlay && overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  /* ======================================================
     17. PRODUCT RECOMMENDATIONS (Shopify's real recommendation API)
     ====================================================== */
  function initRecommendations() {
    var container = document.querySelector('[data-recommendations]');
    if (!container || !container.dataset.url) return;

    fetch(container.dataset.url)
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(container.id);
        if (fresh && fresh.querySelector('.product-card')) {
          container.innerHTML = fresh.innerHTML;
        } else if (!container.querySelector('.product-card')) {
          // Neither the fallback nor the real recommendations produced
          // anything (e.g. brand new store, no order history yet) — hide
          // the empty "You may also like" heading rather than show nothing.
          var wrap = container.closest('.related-products');
          if (wrap) wrap.hidden = true;
        }
      })
      .catch(function () {});
  }

  /* ======================================================
     SITEWIDE POPUPS (sale popup + corner signup)
     ====================================================== */
  var POPUP_DAY_MS = 24 * 60 * 60 * 1000;

  function popupStorageKey(id) { return 'nuviPopupLastShown_' + id; }

  function popupShouldShow(id, frequency) {
    if (frequency === 'always') return true;
    var key = popupStorageKey(id);
    if (frequency === 'day') {
      var last = Number(window.localStorage.getItem(key) || 0);
      return !last || (Date.now() - last) > POPUP_DAY_MS;
    }
    // default: once per browser session
    return !window.sessionStorage.getItem(key);
  }

  function popupMarkShown(id, frequency) {
    var key = popupStorageKey(id);
    if (frequency === 'day') {
      window.localStorage.setItem(key, String(Date.now()));
    } else if (frequency !== 'always') {
      window.sessionStorage.setItem(key, '1');
    }
  }

  function openPromoPopup(popup) {
    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }

  function closePromoPopup(popup) {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { popup.hidden = true; }, 300);
  }

  function initPromoPopup() {
    var popup = document.querySelector('[data-promo-popup]');
    if (!popup) return;

    var frequency = popup.dataset.promoFrequency || 'session';
    var delay = Number(popup.dataset.promoDelay || 0);
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile && popup.dataset.promoMobile === 'false') return;
    if (!isMobile && popup.dataset.promoDesktop === 'false') return;
    if (!popupShouldShow('promo', frequency)) return;

    setTimeout(function () {
      openPromoPopup(popup);
      popupMarkShown('promo', frequency);
    }, delay);

    popup.querySelectorAll('[data-promo-close]').forEach(function (el) {
      el.addEventListener('click', function () { closePromoPopup(popup); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePromoPopup(popup);
    });
  }

  function initCornerSignup() {
    var box = document.querySelector('[data-corner-signup]');
    if (!box) return;

    var frequency = box.dataset.popupFrequency || 'day';
    var delay = Number(box.dataset.popupDelay || 0);

    if (!popupShouldShow('cornerSignup', frequency)) return;

    setTimeout(function () {
      box.hidden = false;
      requestAnimationFrame(function () { box.classList.add('is-open'); });
      popupMarkShown('cornerSignup', frequency);
    }, delay);

    var closeBtn = box.querySelector('[data-corner-signup-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        box.classList.remove('is-open');
        setTimeout(function () { box.hidden = true; }, 300);
      });
    }
  }

  function initUgcGallery() {
    var rows = document.querySelectorAll('[data-ugc-row]');
    if (!rows.length) return;

    // Rows with more videos than fit in one row (data-ugc-rail) scroll
    // horizontally instead of wrapping. Wire up the prev/next arrows and
    // hide the nav row entirely when the rail doesn't actually overflow
    // at the current viewport width (e.g. a wide desktop window).
    document.querySelectorAll('.ugc-gallery').forEach(function (section) {
      var rail = section.querySelector('[data-ugc-rail]');
      var nav = section.querySelector('[data-ugc-nav]');
      var prevBtn = section.querySelector('[data-ugc-prev]');
      var nextBtn = section.querySelector('[data-ugc-next]');
      if (!rail || !nav) return;

      var scrollStep = function () {
        var tile = rail.querySelector('.ugc-tile');
        return tile ? tile.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
      };
      prevBtn && prevBtn.addEventListener('click', function () { rail.scrollBy({ left: -scrollStep(), behavior: 'smooth' }); });
      nextBtn && nextBtn.addEventListener('click', function () { rail.scrollBy({ left: scrollStep(), behavior: 'smooth' }); });

      var syncNavVisibility = function () {
        var overflowing = rail.scrollWidth > rail.clientWidth + 1;
        nav.classList.toggle('is-hidden', !overflowing);
      };
      syncNavVisibility();
      window.addEventListener('resize', syncNavVisibility);
    });

    var videos = [];
    rows.forEach(function (row) {
      row.querySelectorAll('.ugc-tile__video').forEach(function (el) {
        if (el.tagName === 'VIDEO') videos.push(el);
      });
    });

    if (videos.length && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });
      videos.forEach(function (video) { observer.observe(video); });
    }

    rows.forEach(function (row) {
      row.querySelectorAll('[data-ugc-mute]').forEach(function (btn) {
        var tile = btn.closest('.ugc-tile');
        var video = tile && tile.querySelector('.ugc-tile__video');
        if (!video || video.tagName !== 'VIDEO') return;
        btn.addEventListener('click', function () {
          video.muted = !video.muted;
          btn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
          btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        });
      });
    });

    // Swap the heading to reference the active festival (using the same
    // FESTIVALS data + nuvi:festival-change event the announcement bar and
    // festival FX already use), and restore the default once it ends.
    var headings = document.querySelectorAll('[data-ugc-heading]');
    if (headings.length) {
      var applyUgcHeading = function (festival) {
        headings.forEach(function (heading) {
          if (festival) {
            var template = heading.dataset.ugcHeadingTemplate || '{festival}';
            heading.textContent = template
              .replace('{festival}', festival.label)
              .replace('{emoji}', festival.emoji || '');
          } else {
            heading.textContent = heading.dataset.ugcHeadingDefault || heading.textContent;
          }
        });
      };

      // Pick up whatever festival state initFestivals() already applied to
      // <html> before this runs, so a festival active on first load shows
      // immediately (not just on the next festival-change event).
      applyUgcHeading(findFestival(document.documentElement.dataset.festival));
      document.addEventListener('nuvi:festival-change', function (e) {
        applyUgcHeading(e.detail.festival);
      });
    }
  }

  /* ======================================================
     18. FIT FINDER (size from age, height and weight)
     ======================================================
     Height decides a garment's length, weight decides how it fits around
     the chest and waist. Each measurement is placed on the size chart as a
     position (5.5 = halfway through the 6th size), then a per-garment rule
     decides which one leads:
       onepiece (sleepsuit, romper, sets) - both must fit: the larger wins
       top (frock, dress, tee)            - weight leads; may be half a size short
       bottom (pants, leggings, shorts)   - height leads; elastic waist allows half a size
     Fit preference: snug = the size that contains the child, regular = size
     up in the last 20% of a size, grow = one more size up.
     Everything runs in the browser; measurements never leave the page and
     aren't saved - each product and each page load starts empty. */
  var FIT_OLD_PROFILE_KEY = 'nuvi:fit-profile'; // saved by an earlier version; now deleted on load
  var FIT_HEIGHT_LIMITS = [40, 150];
  var FIT_WEIGHT_LIMITS = [2, 45];

  // "0-3 Months", "0-3 months", "0-3M" -> "0-3m"; "1-2 Years", "1-2Y" -> "1-2y"
  function normalizeSizeLabel(label) {
    return String(label == null ? '' : label).toLowerCase()
      .replace(/months?|mths?|mos?\b/g, 'm')
      .replace(/years?|yrs?/g, 'y')
      .replace(/[^a-z0-9.-]/g, '');
  }

  function parseFitRange(text) {
    var match = String(text || '').match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/);
    if (!match) return null;
    var min = parseFloat(match[1]);
    var max = parseFloat(match[2]);
    return max > min ? [min, max] : null;
  }

  // One size per line:
  //   "size | age (months) | height (cm) | weight (kg) | neck | waist | hip | inside leg (cm)".
  // Neck onwards are optional body measurements (they feed the sketch).
  // Blank lines and lines starting with # are ignored.
  function parseSizeChart(text) {
    return String(text || '').split(/\r?\n/).map(function (line) {
      line = line.trim();
      if (!line || line.charAt(0) === '#') return null;
      var parts = line.split('|');
      var label = (parts[0] || '').trim();
      var entry = {
        label: label,
        key: normalizeSizeLabel(label),
        age: parseFitRange(parts[1]),
        height: parseFitRange(parts[2]),
        weight: parseFitRange(parts[3]),
        neck: parseFitRange(parts[4]),
        waist: parseFitRange(parts[5]),
        hip: parseFitRange(parts[6]),
        inseam: parseFitRange(parts[7])
      };
      return label && (entry.age || entry.height || entry.weight) ? entry : null;
    }).filter(Boolean);
  }

  // Position of a measurement on the chart: index of the size whose range
  // holds it, plus how far through that range it is (0..1).
  function fitPosition(chart, field, value) {
    var first = null;
    var last = null;
    for (var i = 0; i < chart.length; i++) {
      var range = chart[i][field];
      if (!range) continue;
      if (first === null) {
        first = i;
        if (value < range[0]) return i;
      }
      if (value < range[1]) {
        return value < range[0] ? i : i + (value - range[0]) / (range[1] - range[0]);
      }
      last = i;
    }
    if (last === null) return null;
    var top = chart[last][field];
    return last + (value - top[0]) / (top[1] - top[0]);
  }

  function nearestSizeIndex(target, indexes) {
    var best = null;
    indexes.forEach(function (i) {
      // Prefer the next size up over the next size down when equally close.
      var score = Math.abs(i - target) + (i < target ? 0.01 : 0);
      if (best === null || score < best.score) best = { index: i, score: score };
    });
    return best ? best.index : null;
  }

  /**
   * opts: { chart, ageMonths, heightCm, weightKg, rule, fit, productSizes }
   *   productSizes: optional [{ key, label, available }] - the sizes this
   *   product actually has; the answer is always one of them.
   * Returns { status: 'ok' | 'empty' | 'invalid' | 'implausible' | 'no-chart', ... }
   */
  function recommendSize(opts) {
    var chart = opts.chart || [];
    var num = function (v) { return v === '' || v == null || isNaN(Number(v)) ? null : Number(v); };
    var age = num(opts.ageMonths);
    var height = num(opts.heightCm);
    var weight = num(opts.weightKg);
    var rule = opts.rule || 'top';
    var fit = opts.fit || 'regular';

    if (height !== null && (height < FIT_HEIGHT_LIMITS[0] || height > FIT_HEIGHT_LIMITS[1])) {
      return { status: 'invalid', field: 'height', message: 'Enter a height between ' + FIT_HEIGHT_LIMITS[0] + ' and ' + FIT_HEIGHT_LIMITS[1] + ' cm.' };
    }
    if (weight !== null && (weight < FIT_WEIGHT_LIMITS[0] || weight > FIT_WEIGHT_LIMITS[1])) {
      return { status: 'invalid', field: 'weight', message: 'Enter a weight between ' + FIT_WEIGHT_LIMITS[0] + ' and ' + FIT_WEIGHT_LIMITS[1] + ' kg.' };
    }

    var productKeys = opts.productSizes ? opts.productSizes.map(function (s) { return s.key; }) : null;
    var candidates = [];
    chart.forEach(function (entry, i) {
      if (!productKeys || productKeys.indexOf(entry.key) !== -1) candidates.push(i);
    });
    if (!candidates.length) return { status: 'no-chart' };

    var A = age !== null ? fitPosition(chart, 'age', age) : null;
    var H = height !== null ? fitPosition(chart, 'height', height) : null;
    var W = weight !== null ? fitPosition(chart, 'weight', weight) : null;
    if (A === null && H === null && W === null) return { status: 'empty' };
    if (H !== null && W !== null && Math.abs(W - H) >= 3) {
      return { status: 'implausible', message: 'That height and weight look unusual together. Please double-check both.' };
    }

    var L = H !== null ? H : A;
    var lengthBy = H !== null ? 'height' : 'age';
    var need;
    var reason;
    if (W === null) {
      need = L;
      reason = 'Based on ' + lengthBy + '.';
    } else if (L === null) {
      need = W;
      reason = 'Based on weight.';
    } else if (rule === 'onepiece') {
      need = Math.max(L, W);
      reason = (W > L ? 'Weight' : 'Height') + ' leads: a one-piece or set has to fit both length and body.';
    } else if (rule === 'bottom') {
      need = Math.max(L, W - 0.5);
      reason = L >= W - 0.5
        ? 'Height leads: trouser length can\'t be added later.'
        : 'Weight leads: even with an elastic waist, the waist needs room.';
    } else {
      need = Math.max(W, L - 0.5);
      reason = W >= L - 0.5
        ? 'Weight leads: the chest has to fit comfortably.'
        : 'Height leads: your child is tall enough that length decides.';
    }

    var last = chart.length - 1;
    var containing = Math.max(0, Math.floor(need));
    var base = Math.max(0, Math.floor(need + (fit === 'snug' ? 0 : 0.2)));
    var target = Math.min(base + (fit === 'grow' ? 1 : 0), last);
    var beyond = need >= chart.length;

    var notes = [];

    // Child outside the sizes this product comes in: say so rather than
    // quietly offering the nearest size (e.g. a 7-year-old and a 2-3Y/3-4Y item).
    if (opts.productSizes) {
      var smallest = candidates[0];
      var largest = candidates[candidates.length - 1];
      var range = chart[smallest].label === chart[largest].label
        ? 'only in ' + chart[smallest].label
        : 'in ' + chart[smallest].label + ' to ' + chart[largest].label;
      var childSize = chart[Math.min(base, last)].label;
      if (base > largest) {
        return { status: 'out-of-range', direction: 'too-small', likely: childSize,
          message: 'This item comes ' + range + '. Your child is likely ' + childSize + ' or bigger, so it will probably be too small.' };
      }
      if (base < smallest) {
        return { status: 'out-of-range', direction: 'too-big', likely: childSize,
          message: 'This item comes ' + range + '. Your child is likely ' + childSize + ', so it will be big for now.' };
      }
      if (target > largest) {
        target = largest;
        notes.push('There\'s no bigger size in this item for extra room to grow.');
      }
    }
    if (H !== null && W !== null) {
      if (W - H >= 0.75) notes.push('Your child is sturdier than average for their height, so we sized for comfort around the chest and waist.');
      else if (W - H <= -0.75) notes.push('Your child is slimmer than average for their height.');
    }
    if (fit === 'regular' && base > containing && containing <= last) {
      notes.push('Sized up because your child is near the top of ' + chart[Math.min(containing, last)].label + '.');
    }
    if (fit === 'grow' && target > base) notes.push('One size up for room to grow.');
    if (beyond) notes.push(chart[last].label + ' is our largest size and may be snug.');

    // Snap to a size this product actually has, then to one that's in stock.
    var index = nearestSizeIndex(target, candidates);
    var soldOut = null;
    if (opts.productSizes) {
      var byKey = {};
      opts.productSizes.forEach(function (s) { byKey[s.key] = s; });
      if (byKey[chart[index].key] && byKey[chart[index].key].available === false) {
        var inStock = candidates.filter(function (i) { return byKey[chart[i].key].available !== false; });
        soldOut = chart[index].label;
        var alternative = nearestSizeIndex(index, inStock);
        if (alternative === null) {
          notes.push(soldOut + ' is sold out, and so are the other sizes in this colour.');
        } else {
          notes.push(soldOut + ' is sold out in this colour, so we suggest ' + chart[alternative].label + ', the closest size in stock.');
          index = alternative;
        }
      }
    }

    if (L !== null && index - L >= 0.9) {
      notes.push(rule === 'bottom' ? 'They will be long. Roll up the hems for now.' : 'It will be a little long. Great for growing into.');
    }
    if (W !== null && index - W >= 1.3) notes.push('It may feel roomy around the body.');
    if (H !== null && A !== null && Math.abs(A - need) >= 2) {
      notes.push('Age alone suggests ' + chart[Math.min(Math.max(0, Math.floor(A)), last)].label + ', but height and weight are more accurate, so we went by those.');
    }

    return {
      status: 'ok',
      index: index,
      label: chart[index].label,
      key: chart[index].key,
      soldOut: soldOut,
      reason: reason,
      notes: notes,
      positions: { age: A, height: H, weight: W, need: need }
    };
  }

  /* ---------- fit finder: measurements + child sketch ---------- */

  function fitClamp(value, min, max) { return Math.max(min, Math.min(max, value)); }
  function fitMid(range) { return range ? (range[0] + range[1]) / 2 : null; }
  function fitRound(value) { return Math.round(value * 2) / 2; } // nearest half cm

  // Value of a chart column at a chart position (the inverse of fitPosition).
  function chartValueAt(chart, field, position) {
    if (position === null || position === undefined || !chart.length) return null;
    var index = fitClamp(Math.floor(position), 0, chart.length - 1);
    var range = chart[index][field];
    if (!range) return null;
    var fraction = fitClamp(position - index, -0.5, 1.5);
    return range[0] + fraction * (range[1] - range[0]);
  }

  /**
   * The child's measurements for the sketch. Height is what the parent typed
   * (else read from age/weight); neck and waist are estimated from weight
   * (girth follows weight), else from height or age. null if nothing entered.
   */
  function estimateMeasurements(chart, opts) {
    var num = function (v) { return v === '' || v == null || isNaN(Number(v)) ? null : Number(v); };
    var age = num(opts.ageMonths);
    var height = num(opts.heightCm);
    var weight = num(opts.weightKg);
    var Hp = height !== null ? fitPosition(chart, 'height', height) : (age !== null ? fitPosition(chart, 'age', age) : null);
    var Wp = weight !== null ? fitPosition(chart, 'weight', weight) : null;
    var girth = Wp !== null ? Wp : Hp;
    if (Hp === null && girth === null) return null;
    var length = Hp !== null ? Hp : girth;
    return {
      height: { value: height !== null ? height : chartValueAt(chart, 'height', length), measured: height !== null },
      neck: { value: chartValueAt(chart, 'neck', girth), measured: false },
      waist: { value: chartValueAt(chart, 'waist', girth), measured: false },
      // Hip follows weight like waist; inside leg follows height.
      hip: { value: chartValueAt(chart, 'hip', girth), measured: false },
      inseam: { value: chartValueAt(chart, 'inseam', length), measured: false },
      basis: weight !== null ? 'weight' : (height !== null ? 'height' : 'age')
    };
  }

  function typicalMeasurements(entry) {
    return {
      height: { value: fitMid(entry.height), measured: false },
      neck: { value: fitMid(entry.neck), measured: false },
      waist: { value: fitMid(entry.waist), measured: false },
      hip: { value: fitMid(entry.hip), measured: false },
      inseam: { value: fitMid(entry.inseam), measured: false }
    };
  }

  /**
   * Compare the child with a size: one row per measurement the chart has.
   * status: good | roomy | tight (neck, waist, hip) or good | long | short
   * (height, inside leg). Hip and inside leg only for products with a bottom.
   */
  function compareToSize(entry, measurements, opts) {
    var bottom = !!(opts && opts.bottom);
    var rows = [];
    function add(field, label, range, value, measured, loose, snug, words) {
      if (!range || value === null) return;
      var status = 'good';
      if (value > range[1] + snug) status = words[1];
      else if (value < range[0] - loose) status = words[0];
      rows.push({ field: field, label: label, value: value, measured: measured, range: range, status: status });
    }
    add('height', 'Height', entry.height, measurements.height.value, measurements.height.measured, 3, 1, ['long', 'short']);
    add('neck', 'Neck', entry.neck, measurements.neck.value, false, 1.5, 0.5, ['roomy', 'tight']);
    add('waist', 'Waist', entry.waist, measurements.waist.value, false, 2.5, 1, ['roomy', 'tight']);
    if (bottom && measurements.hip) add('hip', 'Hip', entry.hip, measurements.hip.value, false, 2.5, 1, ['roomy', 'tight']);
    if (bottom && measurements.inseam) add('inseam', 'Inside leg', entry.inseam, measurements.inseam.value, false, 3, 1, ['long', 'short']);
    return rows;
  }

  // Sketch geometry, in SVG units (viewBox 0 0 240 300; feet on y = 292).
  // Scaled so the tallest figure fills the box; the ruler shows real cm.
  var KID_SKETCH = { ground: 292, cx: 112, maxFigure: 238 };

  function kidScale(heightCm) {
    return fitClamp(KID_SKETCH.maxFigure / heightCm, 1.8, 3.4);
  }

  function kidGeometry(heightCm, neckCm, waistCm, px, hipCm) {
    px = px || kidScale(heightCm);
    var H = heightCm * px;
    var ground = KID_SKETCH.ground;
    var top = ground - H;
    // Younger children: bigger head and shorter legs relative to height.
    var headH = H * fitClamp(0.235 - (heightCm - 80) * 0.0012, 0.18, 0.25);
    var legFrac = fitClamp(0.40 + (heightCm - 80) * 0.0016, 0.38, 0.48);
    // Fall back to typical proportions when the chart has no neck/waist.
    var waistW = (waistCm || heightCm * 0.53) / 2.9 * px;
    var neckW = (neckCm || heightCm * 0.27) / 3.1 * px;
    var chinY = top + headH;
    var shoulderY = chinY + H * 0.035;
    var crotchY = ground - H * legFrac;
    return {
      px: px, H: H, top: top, ground: ground, cx: KID_SKETCH.cx,
      headH: headH, headW: headH * 0.88, chinY: chinY, shoulderY: shoulderY, crotchY: crotchY,
      waistY: shoulderY + (crotchY - shoulderY) * 0.62,
      hipY: shoulderY + (crotchY - shoulderY) * 0.86,
      waistW: waistW, neckW: neckW,
      shoulderW: Math.max(waistW * 1.12, H * 0.24),
      hipW: hipCm ? Math.max(hipCm / 3 * px, waistW * 1.02) : waistW * 1.05,
      armW: Math.max(waistW * 0.24, H * 0.05),
      legW: Math.max(waistW * 0.36, H * 0.07)
    };
  }

  function svgNum(n) { return Math.round(n * 10) / 10; }
  function svgPoints(points) {
    return points.map(function (p, i) { return (i ? 'L' : 'M') + svgNum(p[0]) + ' ' + svgNum(p[1]); }).join(' ');
  }

  // Dashed silhouette of the selected size, drawn behind the child.
  function kidOutlineSvg(g) {
    var cx = g.cx;
    var left = [
      [cx - g.neckW / 2, g.chinY],
      [cx - g.shoulderW / 2, g.shoulderY + 2],
      [cx - g.shoulderW / 2 - g.armW * 0.9, g.crotchY - g.H * 0.01],
      [cx - g.shoulderW / 2 + g.armW * 0.1, g.crotchY - g.H * 0.01],
      [cx - g.shoulderW / 2 + g.armW * 0.55, g.shoulderY + g.H * 0.12],
      [cx - g.waistW / 2, g.waistY],
      [cx - g.hipW / 2, g.hipY],
      [cx - g.hipW / 4 - g.legW * 0.45, g.ground - 1],
      [cx - g.hipW / 4 + g.legW * 0.45, g.ground - 1]
    ];
    var right = left.slice().reverse().map(function (p) { return [2 * cx - p[0], p[1]]; });
    var body = svgPoints(left.concat([[cx, g.crotchY + 2]], right)) + ' Z';
    return '<g class="kid-sketch__outline" fill="none" stroke="#30453E" stroke-opacity="0.5" stroke-width="1.3" stroke-dasharray="4 3">' +
      '<ellipse cx="' + svgNum(cx) + '" cy="' + svgNum(g.top + g.headH / 2) + '" rx="' + svgNum(g.headW / 2) + '" ry="' + svgNum(g.headH / 2) + '"/>' +
      '<path d="' + body + '"/></g>';
  }

  // Outfit colours: girls pink, boys mint, otherwise peach.
  var KID_PALETTES = {
    girl: { top: ['#FAD0DC', '#EE9DB3'], bottom: ['#C9B8E8', '#9F8BCF'] },
    boy: { top: ['#C4E8DA', '#8CC7B0'], bottom: ['#7FA2CB', '#4E6E99'] },
    neutral: { top: ['#F8C9B9', '#EE9F88'], bottom: ['#86ADD3', '#5B86B2'] }
  };

  /**
   * Illustrated child with soft shading.
   *   gender 'girl': long hair with a bow; a frock unless the product has a
   *   bottom (then top + shorts so the legs/hip are visible).
   *   gender 'boy' or '': short hair, tee and shorts.
   */
  function kidFigureSvg(g, gender, bottom) {
    var cx = g.cx;
    var ink = '#30453E';
    var girl = gender === 'girl';
    var dress = girl && !bottom;
    var headCy = g.top + g.headH / 2;
    var hemY = g.waistY + g.H * 0.035;
    var shortsBottom = g.crotchY + g.H * 0.075;
    var ankleY = g.ground - g.H * 0.035;
    var legX = g.hipW / 4;
    var shoeRy = Math.max(3.5, g.H * 0.022);
    var mirror = function (points) { return points.slice().reverse().map(function (p) { return [2 * cx - p[0], p[1]]; }); };
    var s = '';

    // Legs, shoes
    [-1, 1].forEach(function (side) {
      var x = cx + side * legX;
      s += '<line x1="' + svgNum(x) + '" y1="' + svgNum(g.crotchY) + '" x2="' + svgNum(x + side * 0.5) + '" y2="' + svgNum(ankleY) + '" stroke="' + ink + '" stroke-width="' + svgNum(g.legW + 2.4) + '" stroke-linecap="round"/>' +
        '<line x1="' + svgNum(x) + '" y1="' + svgNum(g.crotchY) + '" x2="' + svgNum(x + side * 0.5) + '" y2="' + svgNum(ankleY) + '" stroke="#F0C7A2" stroke-width="' + svgNum(g.legW) + '" stroke-linecap="round"/>' +
        '<ellipse cx="' + svgNum(x + side * g.legW * 0.18) + '" cy="' + svgNum(g.ground - shoeRy * 0.9) + '" rx="' + svgNum(g.legW * 0.72) + '" ry="' + svgNum(shoeRy) + '" fill="' + (girl ? '#C0607E' : ink) + '"/>';
    });

    // Shorts (not under a frock)
    if (!dress) {
      s += '<path d="' + svgPoints([
        [cx - g.hipW / 2, g.waistY], [cx + g.hipW / 2, g.waistY],
        [cx + g.hipW / 2 + 3, shortsBottom], [cx + 1.5, shortsBottom], [cx, g.crotchY + 3],
        [cx - 1.5, shortsBottom], [cx - g.hipW / 2 - 3, shortsBottom]
      ]) + ' Z" fill="url(#kidShorts)" stroke="' + ink + '" stroke-width="1.2" stroke-linejoin="round"/>';
    }

    // Arms, hands
    [-1, 1].forEach(function (side) {
      var x1 = cx + side * (g.shoulderW / 2 - g.armW * 0.35);
      var x2 = cx + side * (g.shoulderW / 2 + g.armW * 0.45);
      var y2 = g.crotchY - g.H * 0.02;
      s += '<line x1="' + svgNum(x1) + '" y1="' + svgNum(g.shoulderY + g.armW * 0.75) + '" x2="' + svgNum(x2) + '" y2="' + svgNum(y2) + '" stroke="' + ink + '" stroke-width="' + svgNum(g.armW + 2.4) + '" stroke-linecap="round"/>' +
        '<line x1="' + svgNum(x1) + '" y1="' + svgNum(g.shoulderY + g.armW * 0.75) + '" x2="' + svgNum(x2) + '" y2="' + svgNum(y2) + '" stroke="#F0C7A2" stroke-width="' + svgNum(g.armW) + '" stroke-linecap="round"/>';
    });

    // Top: a T-shirt, or a frock that flares to the knee
    var upper = [
      [cx - g.neckW / 2 - 1, g.shoulderY - 1],
      [cx - g.shoulderW / 2, g.shoulderY + 2],
      [cx - g.shoulderW / 2 - g.armW * 0.5, g.shoulderY + g.H * 0.1],
      [cx - g.shoulderW / 2 + g.armW * 0.55, g.shoulderY + g.H * 0.12],
      [cx - g.waistW / 2, g.waistY]
    ];
    var lower = dress
      ? [[cx - g.hipW * 0.95, g.crotchY + g.H * 0.15]]
      : [[cx - g.hipW / 2 - 1, hemY]];
    var top = upper.concat(lower);
    var collar = ' Q' + svgNum(cx) + ' ' + svgNum(g.shoulderY + g.neckW * 0.55) + ' ' + svgNum(cx - g.neckW / 2 - 1) + ' ' + svgNum(g.shoulderY - 1) + ' Z';
    s += '<path d="' + svgPoints(top.concat(mirror(top))) + collar + '" fill="url(#kidTee)" stroke="' + ink + '" stroke-width="1.2" stroke-linejoin="round"/>';
    if (dress) {
      s += '<path d="M' + svgNum(cx - g.waistW / 2) + ' ' + svgNum(g.waistY) + ' Q' + svgNum(cx) + ' ' + svgNum(g.waistY + 3) + ' ' + svgNum(cx + g.waistW / 2) + ' ' + svgNum(g.waistY) + '" fill="none" stroke="' + ink + '" stroke-width="1"/>';
    }
    // Little star on the chest
    var starR = g.waistW * 0.13;
    var starY = g.shoulderY + (g.waistY - g.shoulderY) * 0.45;
    s += '<path d="M' + svgNum(cx) + ' ' + svgNum(starY - starR) + ' L' + svgNum(cx + starR * 0.3) + ' ' + svgNum(starY - starR * 0.3) + ' L' + svgNum(cx + starR) + ' ' + svgNum(starY) + ' L' + svgNum(cx + starR * 0.3) + ' ' + svgNum(starY + starR * 0.3) + ' L' + svgNum(cx) + ' ' + svgNum(starY + starR) + ' L' + svgNum(cx - starR * 0.3) + ' ' + svgNum(starY + starR * 0.3) + ' L' + svgNum(cx - starR) + ' ' + svgNum(starY) + ' L' + svgNum(cx - starR * 0.3) + ' ' + svgNum(starY - starR * 0.3) + ' Z" fill="#EAB83D"/>';

    // Long hair falls behind the head onto the shoulders
    if (girl) {
      s += '<path class="kid-sketch__long-hair" d="M' + svgNum(cx - g.headW * 0.52) + ' ' + svgNum(headCy - g.headH * 0.1) +
        ' Q' + svgNum(cx - g.headW * 0.7) + ' ' + svgNum(g.chinY + g.headH * 0.45) + ' ' + svgNum(cx - g.headW * 0.42) + ' ' + svgNum(g.chinY + g.headH * 0.5) +
        ' L' + svgNum(cx + g.headW * 0.42) + ' ' + svgNum(g.chinY + g.headH * 0.5) +
        ' Q' + svgNum(cx + g.headW * 0.7) + ' ' + svgNum(g.chinY + g.headH * 0.45) + ' ' + svgNum(cx + g.headW * 0.52) + ' ' + svgNum(headCy - g.headH * 0.1) + ' Z" fill="#4A3428"/>';
    }

    // Neck, ears, head
    s += '<rect x="' + svgNum(cx - g.neckW / 2) + '" y="' + svgNum(g.chinY - 3) + '" width="' + svgNum(g.neckW) + '" height="' + svgNum(g.shoulderY - g.chinY + 4) + '" fill="url(#kidSkin)" stroke="' + ink + '" stroke-width="1.1"/>';
    [-1, 1].forEach(function (side) {
      s += '<ellipse cx="' + svgNum(cx + side * g.headW * 0.49) + '" cy="' + svgNum(headCy + g.headH * 0.06) + '" rx="' + svgNum(g.headW * 0.09) + '" ry="' + svgNum(g.headH * 0.12) + '" fill="#EDBE97" stroke="' + ink + '" stroke-width="1.1"/>';
    });
    s += '<ellipse cx="' + svgNum(cx) + '" cy="' + svgNum(headCy) + '" rx="' + svgNum(g.headW / 2) + '" ry="' + svgNum(g.headH / 2) + '" fill="url(#kidSkin)" stroke="' + ink + '" stroke-width="1.2"/>';
    // Hair on top (a side fringe for girls)
    s += '<path d="M' + svgNum(cx - g.headW * 0.51) + ' ' + svgNum(headCy - g.headH * 0.02) +
      ' Q' + svgNum(cx - g.headW * 0.55) + ' ' + svgNum(g.top - g.headH * 0.06) + ' ' + svgNum(cx) + ' ' + svgNum(g.top - g.headH * 0.05) +
      ' Q' + svgNum(cx + g.headW * 0.55) + ' ' + svgNum(g.top - g.headH * 0.06) + ' ' + svgNum(cx + g.headW * 0.51) + ' ' + svgNum(headCy - g.headH * 0.02) +
      (girl
        ? ' Q' + svgNum(cx + g.headW * 0.15) + ' ' + svgNum(g.top + g.headH * 0.12) + ' ' + svgNum(cx - g.headW * 0.2) + ' ' + svgNum(g.top + g.headH * 0.32)
        : ' Q' + svgNum(cx + g.headW * 0.3) + ' ' + svgNum(g.top + g.headH * 0.2) + ' ' + svgNum(cx + g.headW * 0.05) + ' ' + svgNum(g.top + g.headH * 0.24)) +
      ' Q' + svgNum(cx - g.headW * 0.25) + ' ' + svgNum(g.top + g.headH * 0.3) + ' ' + svgNum(cx - g.headW * 0.51) + ' ' + svgNum(headCy - g.headH * 0.02) + ' Z" fill="#4A3428"/>';
    if (girl) {
      // Bow
      var bx = cx + g.headW * 0.33;
      var bowY = g.top + g.headH * 0.1;
      var bw = g.headW * 0.16;
      s += '<path class="kid-sketch__bow" d="M' + svgNum(bx) + ' ' + svgNum(bowY) + ' L' + svgNum(bx - bw) + ' ' + svgNum(bowY - bw * 0.7) + ' L' + svgNum(bx - bw) + ' ' + svgNum(bowY + bw * 0.7) + ' Z M' + svgNum(bx) + ' ' + svgNum(bowY) + ' L' + svgNum(bx + bw) + ' ' + svgNum(bowY - bw * 0.7) + ' L' + svgNum(bx + bw) + ' ' + svgNum(bowY + bw * 0.7) + ' Z" fill="#E86A8E" stroke="' + ink + '" stroke-width="0.8" stroke-linejoin="round"/>' +
        '<circle cx="' + svgNum(bx) + '" cy="' + svgNum(bowY) + '" r="' + svgNum(bw * 0.3) + '" fill="#C0476C"/>';
    }
    // Face
    var eyeY = headCy + g.headH * 0.08;
    var eyeR = Math.max(1.2, g.headW * 0.045);
    [-1, 1].forEach(function (side) {
      s += '<circle cx="' + svgNum(cx + side * g.headW * 0.18) + '" cy="' + svgNum(eyeY) + '" r="' + svgNum(eyeR) + '" fill="' + ink + '"/>' +
        '<circle cx="' + svgNum(cx + side * g.headW * 0.27) + '" cy="' + svgNum(eyeY + g.headH * 0.13) + '" r="' + svgNum(g.headW * 0.07) + '" fill="#F2A3A0" opacity="0.55"/>';
    });
    s += '<path d="M' + svgNum(cx - g.headW * 0.11) + ' ' + svgNum(eyeY + g.headH * 0.15) + ' Q' + svgNum(cx) + ' ' + svgNum(eyeY + g.headH * 0.24) + ' ' + svgNum(cx + g.headW * 0.11) + ' ' + svgNum(eyeY + g.headH * 0.15) + '" fill="none" stroke="' + ink + '" stroke-width="1.2" stroke-linecap="round"/>';
    return '<g class="kid-sketch__child kid-sketch__child--' + (girl ? 'girl' : (gender === 'boy' ? 'boy' : 'neutral')) + (dress ? ' kid-sketch__child--dress' : '') + '">' + s + '</g>';
  }

  // Height ruler, tape loops (neck, waist, hip) and the inside-leg guide.
  // Labels sit on the right, pushed apart so they never overlap.
  function kidMeasuresSvg(g, labels) {
    var px = g.px;
    var s = '';
    s += '<line x1="18" y1="' + svgNum(g.top) + '" x2="18" y2="' + g.ground + '" stroke="#185FA5" stroke-width="1.2"/>';
    for (var cm = 0; g.ground - cm * px >= g.top - 0.5; cm += 10) {
      var y = g.ground - cm * px;
      s += '<line x1="' + (cm % 50 ? 15 : 12) + '" y1="' + svgNum(y) + '" x2="21" y2="' + svgNum(y) + '" stroke="#185FA5" stroke-width="1"/>';
    }
    s += '<line x1="12" y1="' + svgNum(g.top) + '" x2="' + svgNum(g.cx - g.headW / 2 - 3) + '" y2="' + svgNum(g.top) + '" stroke="#185FA5" stroke-width="1" stroke-dasharray="2 2"/>';
    s += '<text x="10" y="' + svgNum(g.top - 6) + '" fill="#185FA5" font-weight="700">Height ' + escapeHtml(labels.height) + '</text>';

    var callouts = [];
    function tape(name, value, cy, rx, ry, color) {
      s += '<ellipse cx="' + svgNum(g.cx) + '" cy="' + svgNum(cy) + '" rx="' + svgNum(rx) + '" ry="' + ry + '" fill="none" stroke="' + color + '" stroke-width="2" stroke-dasharray="3 2"/>';
      callouts.push({ name: name, value: value, x: g.cx + rx, y: cy, color: color });
    }
    if (labels.neck) tape('Neck', labels.neck, (g.chinY + g.shoulderY) / 2 + 1, g.neckW / 2 + 2, 2.6, '#C0602F');
    if (labels.waist) tape('Waist', labels.waist, g.waistY, g.waistW / 2 + 3, 3.4, '#3B6D11');
    if (labels.hip) tape('Hip', labels.hip, g.hipY, g.hipW / 2 + 4, 3.6, '#854F0B');
    if (labels.inseam) {
      var legX = g.cx - g.hipW / 4 + g.legW * 0.5 + 1;
      var y1 = g.crotchY + 4;
      var y2 = g.ground - g.H * 0.04;
      s += '<g class="kid-sketch__inseam"><line x1="' + svgNum(legX) + '" y1="' + svgNum(y1) + '" x2="' + svgNum(legX) + '" y2="' + svgNum(y2) + '" stroke="#534AB7" stroke-width="1.8" stroke-dasharray="3 2"/>' +
        '<path d="M' + svgNum(legX - 3) + ' ' + svgNum(y1 + 5) + ' L' + svgNum(legX) + ' ' + svgNum(y1) + ' L' + svgNum(legX + 3) + ' ' + svgNum(y1 + 5) + ' M' + svgNum(legX - 3) + ' ' + svgNum(y2 - 5) + ' L' + svgNum(legX) + ' ' + svgNum(y2) + ' L' + svgNum(legX + 3) + ' ' + svgNum(y2 - 5) + '" fill="none" stroke="#534AB7" stroke-width="1.5"/></g>';
      callouts.push({ name: 'Inside leg', value: labels.inseam, x: legX, y: (y1 + y2) / 2, color: '#534AB7' });
    }
    var lastY = -Infinity;
    callouts.sort(function (a, b) { return a.y - b.y; }).forEach(function (c) {
      var labelY = Math.max(c.y + 2, lastY + 25);
      lastY = labelY;
      s += '<line x1="' + svgNum(c.x) + '" y1="' + svgNum(c.y) + '" x2="196" y2="' + svgNum(labelY - 3) + '" stroke="' + c.color + '" stroke-width="1"/>' +
        '<text x="198" y="' + svgNum(labelY - 4) + '" fill="' + c.color + '" font-weight="700">' + c.name + '</text>' +
        '<text x="198" y="' + svgNum(labelY + 7) + '" fill="' + c.color + '">' + escapeHtml(c.value) + '</text>';
    });
    return s;
  }

  /**
   * Full sketch.
   *   figure / outline: { heightCm, neckCm, waistCm, hipCm } (outline optional,
   *   drawn dashed behind at the same scale)
   *   labels: { height, neck, waist, hip, inseam } text (all but height optional)
   *   gender: 'girl' | 'boy' | ''   bottom: product has a bottom (pants/skirt)
   */
  function kidSketchSvg(opts) {
    var f = opts.figure;
    var o = opts.outline;
    var palette = KID_PALETTES[opts.gender] || KID_PALETTES.neutral;
    // One scale for both figures so the comparison is true to size.
    var px = kidScale(Math.max(f.heightCm, o ? o.heightCm : 0));
    var g = kidGeometry(f.heightCm, f.neckCm, f.waistCm, px, f.hipCm);
    var described = ['height ' + opts.labels.height];
    ['neck', 'waist', 'hip'].forEach(function (k) { if (opts.labels[k]) described.push(k + ' ' + opts.labels[k]); });
    if (opts.labels.inseam) described.push('inside leg ' + opts.labels.inseam);
    var gradient = function (id, stops) {
      return '<linearGradient id="' + id + '" x1="0" x2="1"><stop offset="0" stop-color="' + stops[0] + '"/><stop offset="1" stop-color="' + stops[1] + '"/></linearGradient>';
    };
    return '<svg class="kid-sketch" viewBox="0 0 252 300" role="img" aria-label="' + escapeHtml('Child sketch: ' + described.join(', ')) + '" font-size="10" font-family="inherit">' +
      '<defs>' +
        gradient('kidSkin', ['#F6D5B6', '#E7B28A']) +
        gradient('kidTee', palette.top) +
        gradient('kidShorts', palette.bottom) +
      '</defs>' +
      '<line x1="8" y1="' + KID_SKETCH.ground + '" x2="232" y2="' + KID_SKETCH.ground + '" stroke="#30453E" stroke-opacity="0.2"/>' +
      (o ? kidOutlineSvg(kidGeometry(o.heightCm, o.neckCm, o.waistCm, px, o.hipCm)) : '') +
      kidFigureSvg(g, opts.gender, opts.bottom) +
      kidMeasuresSvg(g, opts.labels) +
      '</svg>';
  }

  /* ---------- size guide: garment charts, units and diagrams ----------
     Garment measurements (not body size) per garment type, from Theme
     settings > Size guide or a product's custom.size_guide metafield:
       Size | Chest | Length | Shoulder | Sleeve      <- header row
       2-3Y | 58 | 38 | 25 | 11                      <- cm
     The metafield can hold several garments: "[tee]" / "[pants]" sections. */

  var GARMENT_NAMES = { frock: 'Frock', tee: 'T-shirt', shirt: 'Shirt', pants: 'Pants', skirt: 'Skirt' };

  // Column names a merchant might use -> the measurement it means.
  var MEASURE_ALIASES = {
    chest: 'chest', bust: 'chest', waist: 'waist', hip: 'hip', hips: 'hip', seat: 'hip',
    length: 'length', totallength: 'length', fulllength: 'length',
    shoulder: 'shoulder', acrossshoulder: 'shoulder', shoulderwidth: 'shoulder',
    sleeve: 'sleeve', sleevelength: 'sleeve', collar: 'collar', neck: 'collar',
    inseam: 'inseam', insideleg: 'inseam'
  };

  var HOW_TO_MEASURE = {
    chest: 'Lay the garment flat and measure from armpit to armpit, then double it.',
    waist: 'Lay flat and measure straight across the waist, then double it.',
    hip: 'Measure across the widest part of the seat, then double it.',
    length: 'From the highest point of the shoulder down to the hem.',
    shoulder: 'Straight across the back, from shoulder seam to shoulder seam.',
    sleeve: 'From the shoulder seam to the end of the sleeve.',
    collar: 'Around the inside of the neckline.',
    inseam: 'From the crotch seam down the inside leg to the hem.'
  };
  var HOW_TO_MEASURE_BY_GARMENT = {
    frock: { waist: 'Across the narrowest point of the bodice, then double it.' },
    shirt: { length: 'From the collar seam at the back down to the hem.', sleeve: 'From the shoulder seam to the cuff.', chest: 'Button it up, lay flat, measure armpit to armpit, then double it.' },
    pants: { waist: 'Relaxed (elastic not stretched), edge to edge, then double it.', length: 'Down the outside leg, from the top of the waistband to the hem.' },
    skirt: { waist: 'Relaxed (elastic not stretched), edge to edge, then double it.', length: 'From the top of the waistband down to the hem.' }
  };

  function measureKey(name) {
    return MEASURE_ALIASES[String(name || '').toLowerCase().replace(/[^a-z]/g, '')] || null;
  }

  function parseGarmentChart(text) {
    var lines = String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); })
      .filter(function (l) { return l && l.charAt(0) !== '#'; });
    var headerAt = -1;
    for (var i = 0; i < lines.length; i++) {
      if (/^size\s*\|/i.test(lines[i])) { headerAt = i; break; }
    }
    if (headerAt === -1) return null;
    var columns = lines[headerAt].split('|').slice(1).map(function (c) {
      c = c.trim();
      return { label: c, key: measureKey(c) };
    }).filter(function (c) { return c.label; });
    var rows = lines.slice(headerAt + 1).map(function (line) {
      var cells = line.split('|').map(function (c) { return c.trim(); });
      if (!cells[0]) return null;
      return {
        label: cells[0],
        key: normalizeSizeLabel(cells[0]),
        values: columns.map(function (_, i) {
          var n = parseFloat(cells[i + 1]);
          return isNaN(n) ? null : n;
        })
      };
    }).filter(Boolean);
    return columns.length && rows.length ? { columns: columns, rows: rows } : null;
  }

  // "[tee]\nSize | ...\n[pants]\nSize | ..." -> { tee: '...', pants: '...' }
  function parseGarmentSections(text) {
    var sections = {};
    var current = null;
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var heading = line.trim().match(/^\[([a-z-]+)\]$/i);
      if (heading) { current = heading[1].toLowerCase(); sections[current] = ''; return; }
      if (current) sections[current] += line + '\n';
    });
    return sections;
  }

  // cm -> display number in the chosen unit (1 decimal, no trailing .0).
  function formatLength(cm, unit) {
    if (cm === null || cm === undefined || isNaN(cm)) return '–';
    var value = unit === 'in' ? cm / 2.54 : cm;
    return String(Math.round(value * 10) / 10);
  }
  function lengthWithUnit(cm, unit) { return formatLength(cm, unit) + ' ' + (unit === 'in' ? 'in' : 'cm'); }

  function howToMeasure(type, key) {
    var own = HOW_TO_MEASURE_BY_GARMENT[type];
    return (own && own[key]) || HOW_TO_MEASURE[key] || '';
  }

  /**
   * Line drawing of the garment with dashed measurement guides and labels,
   * only for the measurements the chart has. values: { chest: cm, ... }
   */
  function garmentDiagramSvg(type, values, labels, unit) {
    var GR = '#7FA33A';
    var outline = 'fill="#fff" stroke="#5F5E5A" stroke-width="1.6" stroke-linejoin="round"';
    var thin = 'fill="none" stroke="#5F5E5A" stroke-width="1.2"';
    var parts = [];
    function has(key) { return values[key] !== null && values[key] !== undefined; }
    function dashed(x1, y1, x2, y2) {
      return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + GR + '" stroke-width="2" stroke-dasharray="4 3"/>';
    }
    function arrows(x1, y1, x2, y2) {
      var a = Math.atan2(y2 - y1, x2 - x1);
      var head = function (x, y, dir) {
        var b = a + (dir ? 0 : Math.PI);
        return 'M' + svgNum(x - 6 * Math.cos(b - 0.5)) + ' ' + svgNum(y - 6 * Math.sin(b - 0.5)) + ' L' + x + ' ' + y + ' L' + svgNum(x - 6 * Math.cos(b + 0.5)) + ' ' + svgNum(y - 6 * Math.sin(b + 0.5));
      };
      return dashed(x1, y1, x2, y2) + '<path d="' + head(x2, y2, true) + ' ' + head(x1, y1, false) + '" stroke="' + GR + '" stroke-width="2" fill="none"/>';
    }
    function loop(cx, cy, rx) {
      return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + svgNum(rx * 0.13) + '" fill="none" stroke="' + GR + '" stroke-width="2" stroke-dasharray="4 3"/>';
    }
    // Label at (lx, ly); its pointer runs from the text's inner edge to the
    // garment point (x, y), so it never crosses the text.
    function label(key, x, y, lx, ly) {
      var left = lx < x;
      var anchor = left ? 'end' : 'start';
      var edge = left ? lx + 3 : lx - 3;
      var name = labels[key] || key;
      return '<g class="garment-diagram__label" data-measure="' + key + '">' +
        '<line x1="' + x + '" y1="' + y + '" x2="' + edge + '" y2="' + (ly + 3) + '" stroke="#9A9A9A" stroke-width="1"/>' +
        '<text x="' + lx + '" y="' + (ly - 1) + '" text-anchor="' + anchor + '" fill="#30453E">' + escapeHtml(name) + '</text>' +
        '<text x="' + lx + '" y="' + (ly + 12) + '" text-anchor="' + anchor + '" fill="#3B6D11" font-weight="700">' + escapeHtml(lengthWithUnit(values[key], unit)) + '</text></g>';
    }
    function add(key, guide, lbl) { if (has(key)) parts.push(guide + lbl); }

    var shape = '';
    if (type === 'tee' || type === 'shirt') {
      var longSleeve = type === 'shirt';
      shape = '<path d="M115 32 Q150 52 185 32 L232 50 L262 ' + (longSleeve ? '190 L238 196' : '100 L238 112') + ' L222 92 L222 228 Q150 236 78 228 L78 92 L62 ' + (longSleeve ? '196 L38 190' : '112 L38 100') + ' L68 50 Z" ' + outline + '/>';
      if (longSleeve) {
        shape += '<path d="M120 31 L150 58 L180 31 L172 26 L150 46 L128 26 Z" ' + outline + '/><line x1="150" y1="58" x2="150" y2="230" stroke="#5F5E5A" stroke-width="1.2"/>';
        for (var by = 78; by < 225; by += 28) shape += '<circle cx="155" cy="' + by + '" r="2" fill="#5F5E5A"/>';
      } else {
        shape += '<path d="M120 32 Q150 46 180 32" ' + thin + '/>';
      }
      add('collar', loop(150, 34, 32), label('collar', 118, 34, 24, 22));
      add('shoulder', arrows(72, 56, 228, 56), label('shoulder', 205, 56, 252, 22));
      add('chest', loop(150, 118, 72), label('chest', 78, 118, 24, 135));
      add('waist', loop(150, 200, 72), label('waist', 78, 200, 24, 185));
      add('length', arrows(122, 42, 122, 226), label('length', 122, 226, 24, 245));
      add('sleeve', longSleeve ? arrows(238, 58, 256, 186) : arrows(238, 58, 256, 98), label('sleeve', 252, longSleeve ? 140 : 80, 268, longSleeve ? 120 : 140));
    } else if (type === 'frock') {
      shape = '<path d="M118 30 Q150 48 182 30 L212 44 L230 82 L212 92 L204 78 L198 120 L250 232 Q150 246 50 232 L102 120 L96 78 L88 92 L70 82 L88 44 Z" ' + outline + '/>' +
        '<path d="M102 120 Q150 128 198 120" ' + thin + '/>';
      add('collar', loop(150, 33, 30), label('collar', 121, 33, 24, 22));
      add('shoulder', arrows(92, 52, 208, 52), label('shoulder', 190, 52, 252, 22));
      add('chest', loop(150, 92, 52), label('chest', 98, 92, 24, 80));
      add('waist', loop(150, 121, 48), label('waist', 102, 121, 24, 140));
      add('hip', loop(150, 160, 66), label('hip', 84, 160, 24, 195));
      add('length', arrows(150, 40, 150, 238), label('length', 150, 215, 252, 225));
    } else if (type === 'pants') {
      shape = '<path d="M92 26 L208 26 L211 44 L89 44 Z" ' + outline + '/><path d="M89 44 L76 236 L140 236 L150 108 L160 236 L224 236 L211 44" ' + outline + '/>' +
        '<line x1="150" y1="44" x2="150" y2="92" stroke="#5F5E5A" stroke-width="1.2"/>';
      add('waist', loop(150, 30, 60), label('waist', 90, 24, 30, 20));
      add('hip', loop(150, 82, 66), label('hip', 84, 82, 24, 110));
      add('length', arrows(236, 26, 236, 236), label('length', 236, 120, 252, 140));
      add('inseam', arrows(156, 114, 166, 234), label('inseam', 164, 205, 252, 205));
    } else if (type === 'skirt') {
      shape = '<path d="M100 26 L200 26 L202 42 L98 42 Z" ' + outline + '/><path d="M98 42 L58 228 Q150 240 242 228 L202 42" ' + outline + '/>' +
        '<path d="M120 42 L108 230 M180 42 L192 230" fill="none" stroke="#5F5E5A" stroke-width="0.8" opacity="0.5"/>';
      add('waist', loop(150, 30, 52), label('waist', 98, 24, 30, 20));
      add('hip', loop(150, 82, 62), label('hip', 88, 82, 24, 110));
      add('length', arrows(256, 26, 256, 230), label('length', 256, 120, 268, 140));
    }
    var described = Object.keys(labels).filter(has).map(function (k) { return (labels[k] || k) + ' ' + lengthWithUnit(values[k], unit); });
    return '<svg class="garment-diagram" viewBox="-40 0 360 260" role="img" font-size="11" font-family="inherit" aria-label="' +
      escapeHtml((GARMENT_NAMES[type] || 'Garment') + ' measurements: ' + described.join(', ')) + '">' +
      shape + parts.join('') + '</svg>';
  }

  // "24-36 months" -> "2 years", "12-24" -> "1 year", "3-6" -> "3–6 months".
  function ageOptionLabel(range) {
    var a = range[0];
    var b = range[1];
    if (a >= 12 && a % 12 === 0 && b - a === 12) return (a / 12) + (a === 12 ? ' year' : ' years');
    if (a >= 12 && a % 12 === 0 && b % 12 === 0) return (a / 12) + '–' + (b / 12) + ' years';
    return a + '–' + b + ' months';
  }

  // Age choices come only from the sizes this product has, so a parent can't
  // pick an age the item doesn't come in.
  function fillAgeOptions(select, entries) {
    if (!select) return;
    var html = '<option value="">Select age</option>';
    entries.forEach(function (entry) {
      if (!entry.age) return;
      html += '<option value="' + fitMid(entry.age) + '">' + escapeHtml(ageOptionLabel(entry.age)) + '</option>';
    });
    select.innerHTML = html;
  }

  // "This item fits children about 92–104 cm and 13–17 kg." (height in cm or in)
  function fitRangeText(entries, lengthUnit) {
    var span = function (field, unit, convert) {
      var ranges = entries.map(function (e) { return e[field]; }).filter(Boolean);
      if (!ranges.length) return '';
      return convert(Math.min.apply(null, ranges.map(function (r) { return r[0]; }))) + '–' +
        convert(Math.max.apply(null, ranges.map(function (r) { return r[1]; }))) + ' ' + unit;
    };
    var heightUnit = lengthUnit === 'in' ? 'in' : 'cm';
    var parts = [
      span('height', heightUnit, function (v) { return formatLength(v, heightUnit); }),
      span('weight', 'kg', function (v) { return v; })
    ].filter(Boolean);
    return parts.length ? 'This item fits children about ' + parts.join(' and ') + '.' : '';
  }

  function initFitFinder() {
    var root = document.querySelector('[data-fit-finder]');
    if (!root) return;
    var chartScript = root.querySelector('[data-fit-chart]');
    var productScript = document.querySelector('[data-product-json]');
    var group = root.closest('[data-option-index]');
    if (!chartScript || !productScript || !group) return;

    var chart;
    var product;
    try {
      chart = parseSizeChart(JSON.parse(chartScript.textContent));
      product = JSON.parse(productScript.textContent);
    } catch (err) { return; }

    var sizeIndex = Number(group.dataset.optionIndex);
    var pills = Array.prototype.slice.call(group.querySelectorAll('[data-option-value]'));
    var toggle = group.querySelector('[data-fit-finder-toggle]');
    var panel = root.querySelector('[data-fit-panel]');
    var result = root.querySelector('[data-fit-result]');
    var ageInput = root.querySelector('[data-fit-age]');
    var heightInput = root.querySelector('[data-fit-height]');
    var weightInput = root.querySelector('[data-fit-weight]');
    var fitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-fit-mode]'));
    var sketch = root.querySelector('[data-fit-sketch]');
    var sketchCaption = root.querySelector('[data-fit-sketch-caption]');
    var measuresTable = root.querySelector('[data-fit-measures]');
    var heightUnitLabel = root.querySelector('[data-fit-height-unit]');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-guide-tab]'));
    var tabList = root.querySelector('[data-guide-tablist]');
    var unitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-unit]'));
    var guideSizes = root.querySelector('[data-guide-sizes]');
    var guideChart = root.querySelector('[data-guide-chart]');
    var guideHow = root.querySelector('[data-guide-how]');
    var guideNote = root.querySelector('[data-guide-note]');
    // Products with pants/skirts also get hip and inside-leg guidance.
    var bottom = root.dataset.fitBottom === 'true';
    var fit = 'regular';
    var unit = 'cm';
    var activeTab = 'find';
    var guideSizeKey = null;
    var lastRec = { status: 'empty' };

    // Details are never kept: start empty on every product and every page load
    // (also defeats the browser restoring typed values on refresh), and delete
    // anything an earlier version saved.
    [ageInput, heightInput, weightInput].forEach(function (input) { input.value = ''; });
    try { localStorage.removeItem(FIT_OLD_PROFILE_KEY); } catch (e) {}

    var productKeys = pills.map(function (p) { return normalizeSizeLabel(p.dataset.value); });
    var covered = chart.some(function (entry) { return productKeys.indexOf(entry.key) !== -1; });

    // Garment charts for the Size chart / How to measure tabs, limited to this
    // product's sizes (in the product's own size order).
    var guideParts = [];
    var guideScript = root.querySelector('[data-size-guide]');
    if (guideScript) {
      try {
        var guide = JSON.parse(guideScript.textContent);
        var overrides = parseGarmentSections(guide.override);
        (guide.parts || []).forEach(function (type) {
          if (!GARMENT_NAMES[type]) return;
          var garment = parseGarmentChart(overrides[type] || (guide.charts || {})[type]);
          if (!garment) return;
          garment.rows = productKeys.map(function (key) {
            return garment.rows.filter(function (row) { return row.key === key; })[0];
          }).filter(Boolean);
          if (garment.rows.length) guideParts.push({ type: type, chart: garment });
        });
      } catch (err) {}
    }

    if (!covered && !guideParts.length) {
      // Neither the fit chart nor a garment chart describes this product's sizes - don't guess.
      root.hidden = true;
      if (toggle) toggle.hidden = true;
      return;
    }
    // Rendered hidden so it never shows as a dead button without JS.
    if (toggle) toggle.hidden = false;

    var availableTabs = { find: covered, chart: guideParts.length > 0, how: guideParts.length > 0 };
    var defaultTab = covered ? 'find' : 'chart';
    tabs.forEach(function (tab) { tab.hidden = !availableTabs[tab.dataset.guideTab]; });
    if (tabList) tabList.hidden = tabs.filter(function (t) { return !t.hidden; }).length < 2;

    var coveredEntries = chart.filter(function (entry) { return productKeys.indexOf(entry.key) !== -1; });
    fillAgeOptions(ageInput, coveredEntries);
    var rangeHint = root.querySelector('[data-fit-range]');
    function renderRangeHint() { if (rangeHint) rangeHint.textContent = fitRangeText(coveredEntries, unit); }
    renderRangeHint();

    function setOpen(open) {
      panel.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
    }

    function selectedOptions() {
      return product.options.map(function (_, i) {
        var g = document.querySelector('[data-option-index="' + i + '"] .is-selected');
        return g ? g.dataset.value : null;
      });
    }

    // A size is available if some in-stock variant has it with the other options as selected.
    function productSizes() {
      var chosen = selectedOptions();
      return pills.map(function (pill) {
        var value = pill.dataset.value;
        var available = product.variants.some(function (v) {
          if (!v.available || v.options[sizeIndex] !== value) return false;
          return v.options.every(function (opt, i) { return i === sizeIndex || chosen[i] === null || opt === chosen[i]; });
        });
        return { key: normalizeSizeLabel(value), label: value, available: available };
      });
    }

    function chartEntry(key) {
      return chart.filter(function (entry) { return entry.key === key; })[0] || null;
    }

    // The size the sketch compares against: the selected size, else the
    // recommendation, else the first size the chart covers.
    function sketchEntry() {
      var selected = pills.filter(function (p) { return p.classList.contains('is-selected'); })[0];
      return (selected && chartEntry(normalizeSizeLabel(selected.dataset.value))) ||
        (lastRec.status === 'ok' && chartEntry(lastRec.key)) ||
        chart.filter(function (entry) { return productKeys.indexOf(entry.key) !== -1; })[0];
    }

    // Lengths are stored in cm; shown in the shopper's chosen unit.
    function cm(value) { return unit === 'in' ? lengthWithUnit(value, 'in') : fitRound(value) + ' cm'; }
    function rangeText(range, rangeUnit) {
      if (rangeUnit === 'cm' && unit === 'in') return formatLength(range[0], 'in') + '–' + formatLength(range[1], 'in') + ' in';
      return range[0] + '–' + range[1] + ' ' + rangeUnit;
    }
    // Height field value in cm, whatever unit it was typed in.
    function heightInCm() {
      var value = heightInput.value;
      if (value === '' || isNaN(Number(value))) return value;
      return unit === 'in' ? Number(value) * 2.54 : Number(value);
    }

    var STATUS_TEXT = { good: 'Good fit', roomy: 'Roomy', tight: 'Tight', long: 'A little long', short: 'Too short' };

    function renderSketch() {
      if (!sketch) return;
      var entry = sketchEntry();
      if (!entry || !entry.height) { sketch.innerHTML = ''; return; }
      var mine = lastRec.status === 'ok' ? estimateMeasurements(chart, {
        ageMonths: ageInput.value, heightCm: heightInCm(), weightKg: weightInput.value
      }) : null;
      var typical = typicalMeasurements(entry);
      var shape = function (m) { return { heightCm: m.height.value, neckCm: m.neck.value, waistCm: m.waist.value, hipCm: bottom ? m.hip.value : null }; };
      var gender = root.dataset.fitGender || '';

      if (mine) {
        var rows = compareToSize(entry, mine, { bottom: bottom });
        var mineText = function (m) { return m.value !== null ? cm(m.value) : ''; };
        sketch.innerHTML = kidSketchSvg({
          figure: shape(mine),
          outline: shape(typical),
          gender: gender,
          bottom: bottom,
          labels: {
            height: cm(mine.height.value),
            neck: mineText(mine.neck),
            waist: mineText(mine.waist),
            hip: bottom ? mineText(mine.hip) : '',
            inseam: bottom ? mineText(mine.inseam) : ''
          }
        });
        sketchCaption.innerHTML = 'Your child <span class="fit-finder__vs">vs</span> <span class="fit-finder__dashed">' + escapeHtml(entry.label) + '</span>';
        measuresTable.innerHTML =
          '<thead><tr><th scope="col"><span class="visually-hidden">Measurement</span></th><th scope="col">Your child</th><th scope="col">' + escapeHtml(entry.label) + ' fits</th></tr></thead><tbody>' +
          rows.map(function (r) {
            return '<tr><th scope="row">' + r.label + '</th><td>' + cm(r.value) + (r.measured ? '' : ' <span class="fit-finder__est">est.</span>') + '</td>' +
              '<td>' + rangeText(r.range, 'cm') + ' <span class="fit-finder__status fit-finder__status--' + r.status + '">' + STATUS_TEXT[r.status] + '</span></td></tr>';
          }).join('') + '</tbody>' +
          '<caption class="fit-finder__note">' + (bottom ? 'Neck, waist and hip are estimated from ' + (mine.basis === 'weight' ? 'weight' : 'height') + ', inside leg from height.' : 'Neck and waist are estimated from ' + (mine.basis === 'weight' ? 'weight' : 'height') + '.') + ' Measure with a tape for the best fit.</caption>';
      } else {
        sketch.innerHTML = kidSketchSvg({
          figure: shape(typical),
          gender: gender,
          bottom: bottom,
          labels: {
            height: rangeText(entry.height, 'cm'),
            neck: entry.neck ? rangeText(entry.neck, 'cm') : '',
            waist: entry.waist ? rangeText(entry.waist, 'cm') : '',
            hip: bottom && entry.hip ? rangeText(entry.hip, 'cm') : '',
            inseam: bottom && entry.inseam ? rangeText(entry.inseam, 'cm') : ''
          }
        });
        sketchCaption.textContent = 'Typical child in ' + entry.label;
        var typicalRows = [['Height', entry.height, 'cm'], ['Neck', entry.neck, 'cm'], ['Waist', entry.waist, 'cm']]
          .concat(bottom ? [['Hip', entry.hip, 'cm'], ['Inside leg', entry.inseam, 'cm']] : [])
          .concat([['Weight', entry.weight, 'kg']])
          .filter(function (r) { return r[1]; });
        measuresTable.innerHTML =
          '<thead><tr><th scope="col"><span class="visually-hidden">Measurement</span></th><th scope="col">Typical ' + escapeHtml(entry.label) + '</th></tr></thead><tbody>' +
          typicalRows.map(function (r) { return '<tr><th scope="row">' + r[0] + '</th><td>' + rangeText(r[1], r[2]) + '</td></tr>'; }).join('') + '</tbody>';
      }
    }

    function showSizePhoto(key) {
      var slide = Array.prototype.filter.call(document.querySelectorAll('[data-gallery-slide][data-media-size]'), function (s) {
        return !s.hidden && normalizeSizeLabel(s.dataset.mediaSize) === key;
      })[0];
      if (!slide) return '';
      var thumb = document.querySelector('[data-gallery-thumb][data-index="' + slide.dataset.index + '"]');
      if (thumb && !slide.classList.contains('is-active')) thumb.click();
      return slide.dataset.mediaCaption || '';
    }

    function render(rec, caption) {
      if (rec.status === 'empty') { result.hidden = true; return; }
      result.hidden = false;
      result.className = 'fit-finder__result';
      if (rec.status === 'out-of-range') {
        result.classList.add('fit-finder__result--warn');
        result.innerHTML = '<p class="fit-finder__answer">This item may not fit</p><p>' + escapeHtml(rec.message) + '</p>';
        return;
      }
      if (rec.status !== 'ok') {
        result.classList.add('fit-finder__result--error');
        var message = rec.message || 'We couldn\'t find a size for these details.';
        if (rec.field === 'height' && unit === 'in') {
          message = 'Enter a height between ' + formatLength(FIT_HEIGHT_LIMITS[0], 'in') + ' and ' + formatLength(FIT_HEIGHT_LIMITS[1], 'in') + ' in.';
        }
        result.innerHTML = '<p>' + escapeHtml(message) + '</p>';
        return;
      }
      if (rec.soldOut) result.classList.add('fit-finder__result--warn');
      result.innerHTML =
        '<p class="fit-finder__answer">We recommend <strong>' + escapeHtml(rec.label) + '</strong></p>' +
        '<p>' + escapeHtml(rec.reason) + '</p>' +
        (rec.notes.length ? '<ul>' + rec.notes.map(function (n) { return '<li>' + escapeHtml(n) + '</li>'; }).join('') + '</ul>' : '') +
        (caption ? '<p class="fit-finder__caption">Showing ' + escapeHtml(rec.label) + ' on a model. ' + escapeHtml(caption) + '</p>' : '');
    }

    function update(selectSize) {
      var rec = recommendSize({
        chart: chart,
        ageMonths: ageInput.value,
        heightCm: heightInCm(),
        weightKg: weightInput.value,
        rule: root.dataset.fitRule,
        fit: fit,
        productSizes: productSizes()
      });
      pills.forEach(function (pill) {
        pill.classList.toggle('is-recommended', rec.status === 'ok' && normalizeSizeLabel(pill.dataset.value) === rec.key);
      });
      var caption = '';
      if (rec.status === 'ok' && selectSize) {
        var pill = pills.filter(function (p) { return normalizeSizeLabel(p.dataset.value) === rec.key; })[0];
        if (pill && !pill.classList.contains('is-selected')) pill.click();
        caption = showSizePhoto(rec.key);
      }
      lastRec = rec;
      render(rec, caption);
      renderSketch();
      return rec;
    }

    function onInput() { update(true); }

    /* Size chart + How to measure tabs */

    function guideRowFor(part) {
      return part.chart.rows.filter(function (row) { return row.key === guideSizeKey; })[0] || part.chart.rows[0];
    }

    // Size the guide shows: the one the shopper picked in the guide, else the
    // selected size, else the recommendation, else the first.
    function syncGuideSize() {
      var keys = [];
      guideParts.forEach(function (part) {
        part.chart.rows.forEach(function (row) { if (keys.indexOf(row.key) === -1) keys.push(row.key); });
      });
      var selected = pills.filter(function (p) { return p.classList.contains('is-selected'); })[0];
      var candidates = [guideSizeKey, selected && normalizeSizeLabel(selected.dataset.value), lastRec.status === 'ok' && lastRec.key, keys[0]];
      guideSizeKey = candidates.filter(function (k) { return k && keys.indexOf(k) !== -1; })[0] || null;
      return keys;
    }

    function renderGuideSizes(keys) {
      if (!guideSizes) return;
      guideSizes.innerHTML = keys.map(function (key) {
        var pill = pills.filter(function (p) { return normalizeSizeLabel(p.dataset.value) === key; })[0];
        var label = pill ? pill.dataset.value : key;
        return '<button type="button" data-guide-size="' + escapeHtml(key) + '" aria-pressed="' + (key === guideSizeKey) + '">' + escapeHtml(label) + '</button>';
      }).join('');
    }

    function renderGuideChart() {
      if (!guideChart) return;
      guideChart.innerHTML = guideParts.map(function (part) {
        var columns = part.chart.columns;
        var showAge = part.chart.rows.some(function (row) { var e = chartEntry(row.key); return e && e.age; });
        return '<div class="size-guide__part"><p class="size-guide__caption">' + escapeHtml(GARMENT_NAMES[part.type]) + ' measurements (' + unit + ')</p>' +
          '<div class="size-guide__scroll"><table class="size-guide__table"><thead><tr><th scope="col">Size</th>' + (showAge ? '<th scope="col">Age</th>' : '') +
          columns.map(function (c) { return '<th scope="col">' + escapeHtml(c.label) + '</th>'; }).join('') + '</tr></thead><tbody>' +
          part.chart.rows.map(function (row) {
            var entry = chartEntry(row.key);
            var current = row.key === guideSizeKey;
            return '<tr' + (current ? ' class="is-current" aria-current="true"' : '') + '><th scope="row">' + escapeHtml(row.label) + '</th>' +
              (showAge ? '<td>' + (entry && entry.age ? escapeHtml(ageOptionLabel(entry.age)) : '–') + '</td>' : '') +
              row.values.map(function (v) { return '<td>' + formatLength(v, unit) + '</td>'; }).join('') + '</tr>';
          }).join('') + '</tbody></table></div></div>';
      }).join('');
    }

    function renderGuideHow() {
      if (!guideHow) return;
      guideHow.innerHTML = guideParts.map(function (part) {
        var row = guideRowFor(part);
        var values = {};
        var labels = {};
        part.chart.columns.forEach(function (c, i) {
          if (c.key && labels[c.key] === undefined) { values[c.key] = row.values[i]; labels[c.key] = c.label; }
        });
        var steps = part.chart.columns.filter(function (c) { return c.key && howToMeasure(part.type, c.key); });
        return '<div class="size-guide__part"><p class="size-guide__caption">' + escapeHtml(GARMENT_NAMES[part.type]) + ': showing ' + escapeHtml(row.label) + '</p>' +
          '<div class="size-guide__how"><div class="size-guide__diagram">' + garmentDiagramSvg(part.type, values, labels, unit) + '</div>' +
          '<ul class="size-guide__steps">' + steps.map(function (c) {
            return '<li><strong>' + escapeHtml(c.label) + ':</strong> ' + escapeHtml(howToMeasure(part.type, c.key)) + '</li>';
          }).join('') + '</ul></div></div>';
      }).join('');
    }

    function renderGuide() {
      if (!guideParts.length) return;
      renderGuideSizes(syncGuideSize());
      if (activeTab === 'chart') renderGuideChart();
      if (activeTab === 'how') renderGuideHow();
    }

    function activateTab(name, focus) {
      if (!availableTabs[name]) name = defaultTab;
      activeTab = name;
      tabs.forEach(function (tab) {
        var on = tab.dataset.guideTab === name;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      root.querySelectorAll('[data-guide-panel]').forEach(function (p) { p.hidden = p.dataset.guidePanel !== name; });
      var guideTab = name !== 'find';
      if (guideNote) guideNote.hidden = !guideTab;
      if (guideSizes) guideSizes.hidden = !guideTab;
      renderGuide();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activateTab(tab.dataset.guideTab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var shown = tabs.filter(function (t) { return !t.hidden; });
        var at = shown.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        activateTab(shown[(at + shown.length) % shown.length].dataset.guideTab, true);
        e.preventDefault();
      });
    });

    if (guideSizes) {
      guideSizes.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-guide-size]');
        if (!btn) return;
        guideSizeKey = btn.dataset.guideSize;
        renderGuide();
      });
    }

    /* cm / in */

    function setUnit(next) {
      if (next === unit) return;
      // Keep whatever height was typed, converted to the new unit.
      if (heightInput.value !== '' && !isNaN(Number(heightInput.value))) {
        var heightCm = heightInCm();
        heightInput.value = next === 'in' ? formatLength(heightCm, 'in') : String(Math.round(heightCm * 10) / 10);
      }
      unit = next;
      unitButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.unit === unit)); });
      if (heightUnitLabel) heightUnitLabel.textContent = unit;
      heightInput.min = unit === 'in' ? formatLength(FIT_HEIGHT_LIMITS[0], 'in') : FIT_HEIGHT_LIMITS[0];
      heightInput.max = unit === 'in' ? formatLength(FIT_HEIGHT_LIMITS[1], 'in') : FIT_HEIGHT_LIMITS[1];
      heightInput.placeholder = unit === 'in' ? 'e.g. 36' : 'e.g. 92';
      renderRangeHint();
      if (covered) {
        if (lastRec.status !== 'empty' || heightInput.value !== '') update(false);
        else renderSketch();
      }
      renderGuide();
    }
    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () { setUnit(btn.dataset.unit); });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = panel.hidden;
        setOpen(open);
        // Always opens on Find my size (or the size chart when there's no fit chart).
        if (open) activateTab(defaultTab);
      });
    }
    [ageInput, heightInput, weightInput].forEach(function (input) {
      input.addEventListener('change', onInput);
      if (input.tagName === 'INPUT') input.addEventListener('input', onInput);
      // These fields sit inside the product form: Enter must not add to bag.
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    });
    fitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        fit = btn.dataset.fitMode;
        fitButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        onInput();
      });
    });
    // Colour changes alter which sizes are in stock - refresh the advice, but
    // never change the shopper's size choice behind their back. Clicking a
    // size redraws the sketch for that size.
    group.closest('form').addEventListener('click', function (e) {
      var option = e.target.closest('[data-option-value]');
      if (!option) return;
      setTimeout(function () {
        if (group.contains(option)) {
          guideSizeKey = normalizeSizeLabel(option.dataset.value);
          renderSketch();
          renderGuide();
        } else {
          update(false);
        }
      }, 0);
    });

    activateTab(defaultTab);
    renderSketch();
  }

  /* ======================================================
     19. SHOE SIZE GUIDE (footwear products only)
     ======================================================
     Chart from Theme settings > Shoe size guide (or a product's
     custom.shoe_size_chart metafield):
       Age | UK/IND | EUR | Foot length        <- header row
       2-2.5 years | 5C | 22 | 14.9             <- foot length in cm
     Product sizes match a row by EUR ("EU22", "EUR 22", "22") or UK/IND
     ("5C", "UK 5C"). Find my size takes the child's foot length. */

  function shoeSizeKey(label) {
    return String(label == null ? '' : label).toLowerCase().replace(/[^a-z0-9.]/g, '');
  }

  function parseShoeChart(text) {
    var lines = String(text || '').split(/\r?\n/).map(function (l) { return l.trim(); })
      .filter(function (l) { return l && l.charAt(0) !== '#'; });
    if (!lines.length) return null;
    var header = lines[0].split('|').map(function (c) { return c.trim(); });
    var find = function (test) {
      for (var i = 0; i < header.length; i++) if (test(header[i].toLowerCase())) return i;
      return -1;
    };
    var cols = {
      age: find(function (h) { return /age/.test(h); }),
      uk: find(function (h) { return /uk|ind/.test(h); }),
      eur: find(function (h) { return /^eu/.test(h); }),
      foot: find(function (h) { return /foot|length/.test(h); })
    };
    if (cols.foot === -1 || (cols.uk === -1 && cols.eur === -1)) return null;
    var rows = lines.slice(1).map(function (line) {
      var cells = line.split('|').map(function (c) { return c.trim(); });
      var foot = parseFloat(cells[cols.foot]);
      if (isNaN(foot)) return null;
      var row = {
        age: cols.age > -1 ? cells[cols.age] || '' : '',
        uk: cols.uk > -1 ? cells[cols.uk] || '' : '',
        eur: cols.eur > -1 ? cells[cols.eur] || '' : '',
        foot: foot
      };
      var uk = shoeSizeKey(row.uk);
      var eur = shoeSizeKey(row.eur);
      row.keys = [eur && 'eu' + eur, eur && 'eur' + eur, eur, uk, uk && 'uk' + uk, uk && 'ind' + uk, uk && 'ukind' + uk].filter(Boolean);
      return row;
    }).filter(Boolean);
    return rows.length ? { headers: { age: header[cols.age], uk: header[cols.uk], eur: header[cols.eur], foot: header[cols.foot] }, rows: rows } : null;
  }

  function shoeRowForSize(chart, sizeLabel) {
    var key = shoeSizeKey(sizeLabel);
    return chart.rows.filter(function (row) { return row.keys.indexOf(key) !== -1; })[0] || null;
  }

  /**
   * Shoe size from foot length. Each chart row's foot length is the longest
   * foot that size fits, so pick the first size at least as long as the foot.
   *   opts: { rows: [{ label, foot, available }] (this product's sizes, small
   *           to large), footCm, fit: 'regular' | 'grow' }
   */
  function recommendShoeSize(opts) {
    var foot = opts.footCm === '' || opts.footCm == null ? null : Number(opts.footCm);
    if (foot === null || isNaN(foot)) return { status: 'empty' };
    if (foot < 8 || foot > 30) return { status: 'invalid', message: 'Enter a foot length between 8 and 30 cm.' };
    var rows = opts.rows || [];
    if (!rows.length) return { status: 'no-chart' };
    var range = rows.length === 1 ? 'only in ' + rows[0].label : 'in ' + rows[0].label + ' to ' + rows[rows.length - 1].label;
    var index = -1;
    for (var i = 0; i < rows.length; i++) { if (rows[i].foot >= foot) { index = i; break; } }
    if (index === -1) {
      return { status: 'out-of-range', direction: 'too-small',
        message: 'This shoe comes ' + range + ', which fits feet up to ' + rows[rows.length - 1].foot + ' cm. It will probably be too small.' };
    }
    var notes = [];
    if (index === 0 && foot < rows[0].foot - 1.5) {
      return { status: 'out-of-range', direction: 'too-big',
        message: 'This shoe comes ' + range + '. The smallest size fits feet up to ' + rows[0].foot + ' cm, so it will be big for now.' };
    }
    if (opts.fit === 'grow') {
      if (index < rows.length - 1) { index++; notes.push('One size up for room to grow.'); }
      else notes.push('There\'s no bigger size in this shoe for extra room to grow.');
    } else if (rows[index].foot - foot < 0.3 && index < rows.length - 1) {
      notes.push('Your child\'s foot is right at the limit of ' + rows[index].label + '. Consider ' + rows[index + 1].label + ' if they\'re growing fast.');
    }
    if (rows[index].available === false) {
      var next = -1;
      for (var j = index + 1; j < rows.length; j++) { if (rows[j].available !== false) { next = j; break; } }
      if (next === -1) {
        notes.push(rows[index].label + ' is sold out in this colour.');
      } else {
        notes.push(rows[index].label + ' is sold out in this colour, so we suggest ' + rows[next].label + ', the next size up.');
        index = next;
      }
    }
    return { status: 'ok', index: index, label: rows[index].label, notes: notes };
  }

  // Top view of a child's foot with a heel-to-toe ruler and the length.
  function footDiagramSvg(lengthText) {
    var GR = '#7FA33A';
    var skin = 'fill="#F6D9B8" stroke="#B9875F" stroke-width="1.4"';
    var s = '<svg class="foot-diagram" viewBox="0 0 320 210" role="img" font-size="11" font-family="inherit" aria-label="' +
      escapeHtml('Foot length, heel to longest toe: ' + lengthText) + '">';
    // Footprint, heel on the left, toes on the right (big toe on the inner/top edge)
    s += '<path d="M72 128 C44 128 42 76 72 76 C100 76 116 92 140 90 C164 88 182 66 212 66 C238 66 250 84 250 100 C250 118 240 130 214 132 C172 136 112 130 72 128 Z" ' + skin + '/>';
    [[263, 72, 11], [272, 92, 7.5], [272, 108, 6.5], [267, 122, 6], [258, 134, 5]].forEach(function (t) {
      s += '<ellipse cx="' + t[0] + '" cy="' + t[1] + '" rx="' + t[2] + '" ry="' + svgNum(t[2] * 0.92) + '" ' + skin + '/>';
    });
    // Heel-to-toe guide: back of the heel to the tip of the longest toe
    s += '<line x1="46" y1="102" x2="274" y2="102" stroke="' + GR + '" stroke-width="2" stroke-dasharray="4 3"/>' +
      '<path d="M52 97 L46 102 L52 107 M268 97 L274 102 L268 107" fill="none" stroke="' + GR + '" stroke-width="2"/>' +
      '<line x1="46" y1="60" x2="46" y2="160" stroke="#9A9A9A" stroke-width="1" stroke-dasharray="2 2"/>' +
      '<line x1="274" y1="60" x2="274" y2="160" stroke="#9A9A9A" stroke-width="1" stroke-dasharray="2 2"/>';
    // Ruler
    s += '<rect x="36" y="160" width="248" height="22" rx="3" fill="#fff" stroke="#9A9A9A"/>';
    for (var x = 46, n = 0; x <= 274.5; x += 11.4, n++) {
      s += '<line x1="' + svgNum(x) + '" y1="160" x2="' + svgNum(x) + '" y2="' + (n % 5 ? 166 : 170) + '" stroke="#5F5E5A" stroke-width="1"/>';
    }
    s += '<text x="160" y="149" text-anchor="middle" fill="#3B6D11" font-weight="700">' + escapeHtml(lengthText) + '</text>' +
      '<text x="160" y="200" text-anchor="middle" fill="#30453E">Heel to toe length</text>';
    return s + '</svg>';
  }

  function initShoeSizeGuide() {
    var root = document.querySelector('[data-shoe-guide]');
    if (!root) return;
    var group = root.closest('[data-option-index]');
    var chartScript = root.querySelector('[data-shoe-chart]');
    if (!group || !chartScript) return;
    var chart;
    try { chart = parseShoeChart(JSON.parse(chartScript.textContent)); } catch (err) { return; }

    var toggle = root.querySelector('[data-shoe-guide-toggle]');
    var panel = root.querySelector('[data-shoe-guide-panel]');
    var pills = Array.prototype.slice.call(group.querySelectorAll('[data-option-value]'));
    var sizeIndex = Number(group.dataset.optionIndex);
    var productScript = document.querySelector('[data-product-json]');
    var product = null;
    try { product = productScript ? JSON.parse(productScript.textContent) : null; } catch (err) {}

    // This product's sizes that the chart knows, smallest first (chart order).
    var matched = chart ? pills.map(function (pill) {
      return { pill: pill, label: pill.dataset.value, row: shoeRowForSize(chart, pill.dataset.value) };
    }).filter(function (m) { return m.row; }) : [];
    matched.sort(function (a, b) { return chart.rows.indexOf(a.row) - chart.rows.indexOf(b.row); });
    if (!matched.length) {
      root.hidden = true;
      return;
    }
    toggle.hidden = false;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-shoe-tab]'));
    var unitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-shoe-unit]'));
    var footInput = root.querySelector('[data-shoe-foot]');
    var footUnitLabel = root.querySelector('[data-shoe-foot-unit]');
    var fitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-shoe-fit]'));
    var result = root.querySelector('[data-shoe-result]');
    var sizesBar = root.querySelector('[data-shoe-sizes]');
    var chartBox = root.querySelector('[data-shoe-chart-table]');
    var howBox = root.querySelector('[data-shoe-how]');
    var note = root.querySelector('[data-shoe-note]');
    var rangeHint = root.querySelector('[data-shoe-range]');
    var unit = 'cm';
    var fit = 'regular';
    var activeTab = 'find';
    var guideLabel = null;
    footInput.value = '';

    function length(cm) { return lengthWithUnit(cm, unit); }

    function selectedOptions() {
      return product ? product.options.map(function (_, i) {
        var g = document.querySelector('[data-option-index="' + i + '"] .is-selected');
        return g ? g.dataset.value : null;
      }) : [];
    }
    function isAvailable(value) {
      if (!product) return true;
      var chosen = selectedOptions();
      return product.variants.some(function (v) {
        if (!v.available || v.options[sizeIndex] !== value) return false;
        return v.options.every(function (opt, i) { return i === sizeIndex || chosen[i] === null || opt === chosen[i]; });
      });
    }

    function currentLabel() {
      var selected = pills.filter(function (p) { return p.classList.contains('is-selected'); })[0];
      var labels = matched.map(function (m) { return m.label; });
      return [guideLabel, selected && selected.dataset.value, labels[0]].filter(function (l) { return l && labels.indexOf(l) !== -1; })[0];
    }

    function footInCm() {
      var v = footInput.value;
      if (v === '' || isNaN(Number(v))) return v;
      return unit === 'in' ? Number(v) * 2.54 : Number(v);
    }

    function renderRange() {
      if (rangeHint) {
        rangeHint.textContent = 'This shoe fits feet about ' + formatLength(matched[0].row.foot - 0.7, unit) + '–' +
          formatLength(matched[matched.length - 1].row.foot, unit) + ' ' + unit + ' long (heel to toe).';
      }
    }

    function renderFind(selectSize) {
      var rec = recommendShoeSize({
        rows: matched.map(function (m) { return { label: m.label, foot: m.row.foot, available: isAvailable(m.label) }; }),
        footCm: footInCm(),
        fit: fit
      });
      pills.forEach(function (p) { p.classList.toggle('is-recommended', rec.status === 'ok' && p.dataset.value === rec.label); });
      if (rec.status === 'empty') { result.hidden = true; return rec; }
      result.hidden = false;
      result.className = 'fit-finder__result';
      if (rec.status === 'invalid') {
        result.classList.add('fit-finder__result--error');
        var message = unit === 'in' ? 'Enter a foot length between ' + formatLength(8, 'in') + ' and ' + formatLength(30, 'in') + ' in.' : rec.message;
        result.innerHTML = '<p>' + escapeHtml(message) + '</p>';
        return rec;
      }
      if (rec.status === 'out-of-range') {
        result.classList.add('fit-finder__result--warn');
        result.innerHTML = '<p class="fit-finder__answer">This shoe may not fit</p><p>' + escapeHtml(rec.message) + '</p>';
        return rec;
      }
      var row = matched[rec.index].row;
      result.innerHTML = '<p class="fit-finder__answer">We recommend <strong>' + escapeHtml(rec.label) + '</strong></p>' +
        '<p>Fits feet up to ' + escapeHtml(length(row.foot)) + (row.uk ? ' · UK/IND ' + escapeHtml(row.uk) : '') + (row.age ? ' · usually ' + escapeHtml(row.age) : '') + '.</p>' +
        (rec.notes.length ? '<ul>' + rec.notes.map(function (n) { return '<li>' + escapeHtml(n) + '</li>'; }).join('') + '</ul>' : '');
      if (selectSize) {
        var pill = pills.filter(function (p) { return p.dataset.value === rec.label; })[0];
        if (pill && !pill.classList.contains('is-selected')) pill.click();
      }
      return rec;
    }

    function renderSizes() {
      var label = currentLabel();
      sizesBar.innerHTML = matched.map(function (m) {
        return '<button type="button" data-shoe-size="' + escapeHtml(m.label) + '" aria-pressed="' + (m.label === label) + '">' + escapeHtml(m.label) + '</button>';
      }).join('');
    }

    function renderChart() {
      var label = currentLabel();
      var h = chart.headers;
      chartBox.innerHTML = '<div class="size-guide__scroll"><table class="size-guide__table"><thead><tr><th scope="col">Size</th>' +
        (h.age ? '<th scope="col">' + escapeHtml(h.age) + '</th>' : '') +
        (h.uk ? '<th scope="col">' + escapeHtml(h.uk) + '</th>' : '') +
        (h.eur ? '<th scope="col">' + escapeHtml(h.eur) + '</th>' : '') +
        '<th scope="col">Foot length (' + unit + ')</th></tr></thead><tbody>' +
        matched.map(function (m) {
          var current = m.label === label;
          return '<tr' + (current ? ' class="is-current" aria-current="true"' : '') + '><th scope="row">' + escapeHtml(m.label) + '</th>' +
            (h.age ? '<td>' + escapeHtml(m.row.age) + '</td>' : '') +
            (h.uk ? '<td>' + escapeHtml(m.row.uk) + '</td>' : '') +
            (h.eur ? '<td>' + escapeHtml(m.row.eur) + '</td>' : '') +
            '<td>' + formatLength(m.row.foot, unit) + '</td></tr>';
        }).join('') + '</tbody></table></div>';
    }

    function renderHow() {
      var label = currentLabel();
      var row = matched.filter(function (m) { return m.label === label; })[0].row;
      howBox.querySelector('[data-shoe-diagram]').innerHTML = footDiagramSvg(label + ' fits feet up to ' + length(row.foot));
    }

    function renderTab() {
      if (activeTab !== 'find') renderSizes();
      if (activeTab === 'chart') renderChart();
      if (activeTab === 'how') renderHow();
    }

    function activateTab(name, focus) {
      activeTab = name;
      tabs.forEach(function (tab) {
        var on = tab.dataset.shoeTab === name;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      root.querySelectorAll('[data-shoe-panel]').forEach(function (p) { p.hidden = p.dataset.shoePanel !== name; });
      sizesBar.hidden = name === 'find';
      if (note) note.hidden = name === 'find';
      renderTab();
    }

    function setUnit(next) {
      if (next === unit) return;
      if (footInput.value !== '' && !isNaN(Number(footInput.value))) {
        var cm = footInCm();
        footInput.value = next === 'in' ? formatLength(cm, 'in') : String(Math.round(cm * 10) / 10);
      }
      unit = next;
      unitButtons.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.shoeUnit === unit)); });
      if (footUnitLabel) footUnitLabel.textContent = unit;
      footInput.placeholder = unit === 'in' ? 'e.g. 5.9' : 'e.g. 15';
      renderRange();
      if (footInput.value !== '') renderFind(false);
      renderTab();
    }

    toggle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) activateTab('find');
    });
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activateTab(tab.dataset.shoeTab); });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var at = tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1);
        activateTab(tabs[(at + tabs.length) % tabs.length].dataset.shoeTab, true);
        e.preventDefault();
      });
    });
    unitButtons.forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.shoeUnit); }); });
    fitButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        fit = b.dataset.shoeFit;
        fitButtons.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        renderFind(true);
      });
    });
    footInput.addEventListener('input', function () { renderFind(true); });
    footInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    sizesBar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-shoe-size]');
      if (!btn) return;
      guideLabel = btn.dataset.shoeSize;
      renderTab();
    });
    group.closest('form').addEventListener('click', function (e) {
      var option = e.target.closest('[data-option-value]');
      if (!option) return;
      setTimeout(function () {
        if (group.contains(option)) guideLabel = option.dataset.value;
        else if (footInput.value !== '') renderFind(false);
        renderTab();
      }, 0);
    });

    renderRange();
    activateTab('find');
  }

  /* ======================================================
     BOOTSTRAP
     ====================================================== */
  function bootstrap() {
    ready(function () {
      initDayNight();
      initFestivalFxListener();
      initFestivals();
      initGlobalStars();
      initHeroSky();
      initStickyHeader();
      initMegaMenu();
      initMobileMenu();
      initSearchBar();
      initMascotLoader();
      initFooterAccordions();
      initScrollJourney();
      initAnnouncementBar();
      initOfferCountdown();
      initHeroSlider();
      initHeroSlideLinks();
      initCart();
      initProductForm();
      initFitFinder();
      initShoeSizeGuide();
      initFilterDrawer();
      initAccountGate();
      initClientFilters();
      initSubcategoryBubbles();
      initCategoryExplorer();
      initProductCardSwatches();
      initSortForm();
      initReviewsCarousel();
      initCouponCarousel();
      initExploreShopSave();
      initDeliveryChecker();
      initProductPageExtras();
      initStoreLocatorCarousel();
      initCategoryOrbit();
      initShopByOccasion();
      initWishlist();
      initStickyAddToCart();
      initSizeGuide();
      trackRecentlyViewed();
      renderRecentlyViewed();
      initRecommendations();
      initPromoPopup();
      initCornerSignup();
      initUgcGallery();
    });
  }

  /* In a real browser (no `module`), boot immediately — identical to the
     previous behavior. Under Node/CommonJS (unit tests), skip auto-boot
     and export just the testable pieces instead. */
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      computeStickyHeaderTop: computeStickyHeaderTop,
      isPastScrollThreshold: isPastScrollThreshold,
      initStickyHeader: initStickyHeader,
      escapeHtml: escapeHtml,
      isValidHandle: isValidHandle,
      formatMoney: formatMoney,
      cartLineItemHtml: cartLineItemHtml,
      renderDiscountStatus: renderDiscountStatus,
      buildWishlistCard: buildWishlistCard,
      initProductForm: initProductForm,
      initClientFilters: initClientFilters,
      initCategoryExplorer: initCategoryExplorer,
      initStickyAddToCart: initStickyAddToCart,
      initDeliveryChecker: initDeliveryChecker,
      initCouponCarousel: initCouponCarousel,
      initProductPageExtras: initProductPageExtras,
      isValidPincode: isValidPincode,
      deliveryCheckUrl: deliveryCheckUrl,
      parseDeliveryResponse: parseDeliveryResponse,
      initCategoryOrbit: initCategoryOrbit,
      normalizeSizeLabel: normalizeSizeLabel,
      parseSizeChart: parseSizeChart,
      recommendSize: recommendSize,
      initFitFinder: initFitFinder,
      parseShoeChart: parseShoeChart,
      shoeRowForSize: shoeRowForSize,
      recommendShoeSize: recommendShoeSize,
      footDiagramSvg: footDiagramSvg,
      initShoeSizeGuide: initShoeSizeGuide,
      ageOptionLabel: ageOptionLabel,
      parseGarmentChart: parseGarmentChart,
      parseGarmentSections: parseGarmentSections,
      measureKey: measureKey,
      formatLength: formatLength,
      howToMeasure: howToMeasure,
      garmentDiagramSvg: garmentDiagramSvg,
      fitRangeText: fitRangeText,
      estimateMeasurements: estimateMeasurements,
      typicalMeasurements: typicalMeasurements,
      compareToSize: compareToSize,
      kidGeometry: kidGeometry,
      kidSketchSvg: kidSketchSvg
    };
  } else {
    bootstrap();
  }
})();
